<template>
    <div class="column-mapping" :id="id">
        <div class="row">
            <div class="col mb-3" >
                <div class="card mapping-container position-relative p-0" >
                    <button class="btn btn-secondary btn-icon-only-md d-none d-md-block position-absolute" @click="toggleExpand" data-bs-toggle="tooltip" title="Toggle full width" style="right: 12px; top: 5px;">
                        <img :src="is_expanded ? '/img/icons/avid-icons/minimize-4.svg' : '/img/icons/avid-icons/maximize-4.svg'" class="icon" style="width:14px;" alt="">
                    </button>
                    <table class="column-mapping-table mapping-table">
                        <thead class="w-100">
                            <tr>
                                <th>
                                    <div class="flex-column">
                                        <h4 class="ms-3 mb-0">Column Name You're Importing</h4>
                                    </div>
                                </th>
                                <th>
                                    <!-- <div>
                                        <small>Maps to</small>
                                    </div> -->
                                </th>
                                <th>
                                    <div class="flex-column">
                                        <h4 class="mb-0">Avid Column</h4>
                                    </div>
                                </th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody class="w-100 p-2">
                            <tr v-for="(column, i) in mapping" :key="column.id" class="pb-2" :class="getMappingClass(errors.columns[i], column)">
                                <td class="mapping-grid__source">
                                    <div class="input-group mb-2" :class="!column.optional && column.parent != null ? 'dashed-border': ''" :data-bs-toggle="!column.optional && column.parent != null ? 'tooltip' : ''"
                                    title="Optional field">
                                        <accordion-select-with-list-header 
                                            v-if="column.static_text == null || column.static_text == false"
                                            v-model="column.source_column" 
                                            :list_header_text="'Custom Logic'"
                                            :options="src_column_array" 
                                            @editing="editing(column)" 
                                            @update:modelValue="sourceColumnChange(column, i)" 
                                            @listHeaderAction="selectCustomLogic(column)"
                                            :class="{'is-invalid' : errors.columns[i] && errors.columns[i].source != ''}" 
                                            :key="'source-' + column.id"
                                            :id="'source-' + column.id"
                                            :if_allow_edit="if_allow_edit && !ednaButtonDisabled[i]"
                                        ></accordion-select-with-list-header>

                                        <input v-else
                                            type="text" 
                                            v-model="column.static_text_value" 
                                            class="form-control" 
                                            :class="{'is-invalid' : errors.columns[i] && errors.columns[i].source != ''}"
                                            @change="updateStaticText(column)" 
                                            :id="'text' + column.id"
                                            :disabled="!if_allow_edit || ednaButtonDisabled[i]"
                                         aria-label="Static Text Value">

                                        <button 
                                            class="btn btn-secondary" 
                                            v-if="(column.source_column == '' || column.source_column == null || column.static_text )" 
                                            data-bs-toggle="tooltip"
                                            :title="(column.static_text == null || column.static_text == false) ? 'Static Value' : 'Column Options'" 
                                            @click="toggleText(column)"
                                            :disabled="!if_allow_edit || ednaButtonDisabled[i]"
                                        >
                                            <i class="fa fa-font" v-if="column.static_text == null || column.static_text == false"></i>
                                            <i class="fas fa-list" v-else></i>
                                        </button>
                                        <button class="btn btn-secondary btn-custom-logic" 
                                            v-if="column.source_column == 'CUSTOM' && !column.editing && (column.static_text == null || column.static_text == false)" 
                                            data-bs-toggle="tooltip" title="Edit the Custom Logic" 
                                            @click="editing(column)" :disabled="!if_allow_edit || ednaButtonDisabled[i]" >
                                            <img class="icon" src="/img/icons/avid-icons/edit.svg" alt="">
                                        </button>
                                        <button class="btn btn-secondary btn-custom-logic" 
                                            v-if="column.source_column == 'CUSTOM' && column.editing && (column.static_text == null || column.static_text == false) " 
                                            data-bs-toggle="tooltip" title="Close the Custom Logic Editor" 
                                            @click.prevent="stopEditing(column)" 
                                            :disabled="!if_allow_edit || ednaButtonDisabled[i]" >
                                            <img class="icon" src="/img/icons/avid-icons/close.svg" alt=""> 
                                        </button>
                                        <button class="btn btn-secondary" 
                                            v-if="column.source_column != null && (column.static_text == null || column.static_text == false) && (column.source_column != 'CUSTOM' || !hasAnyLogicUnitError(column))" 
                                            data-bs-toggle="tooltip" title="Preview"  
                                            @click="previewSourceColumn(column, i)" :disabled="!if_allow_edit || ednaButtonDisabled[i]">
                                            <i class="fa fa-eye" ></i>
                                        </button>
                                    </div>
                                    <div class="text-danger invalid-feedback" v-if="errors.columns[i] && errors.columns[i].source != ''" v-html="errors.columns[i].source"></div>
                                </td>

                                <td class="mapping-grid_map_to" v-if="column.id!='custom_logic_temp_object'">
                                    <div class="d-flex" style="margin-top: 10px;">
                                        <small>Maps to</small>
                                    </div>
                                </td>

                                <td class="mapping-grid__destination" v-if="column.id!='custom_logic_temp_object'">
                                    <div class="d-flex mb-2">
                                        <div class="mt-1">
                                            <img 
                                                class="icon smaller-icon me-2" 
                                                src="/img/icons/avid-icons/toggle-on-circle-gray.svg" 
                                                v-if="column.data_type == 'boolean'"
                                                data-bs-toggle="tooltip" 
                                                title="Data type: True / False" alt=""
                                            >
                                            <img 
                                                class="icon smaller-icon me-2" 
                                                src="/img/icons/avid-icons/calendar.svg" 
                                                v-if="column.data_type == 'date'"
                                                data-bs-toggle="tooltip" 
                                                title="Data type: Date" alt=""
                                            >
                                            <img 
                                                class="icon smaller-icon me-2" 
                                                src="/img/icons/avid-icons/hashtag.svg" 
                                                v-if="column.data_type == 'integer' || column.data_type == 'numeric'"
                                                data-bs-toggle="tooltip" 
                                                title="Data type: Number" alt=""
                                            >
                                            <img 
                                                class="icon smaller-icon me-2" 
                                                src="/img/icons/avid-icons/text.svg" 
                                                v-if="column.data_type == 'string'"
                                                data-bs-toggle="tooltip" 
                                                title="Data type: Text" alt=""
                                            >
                                            <img 
                                                class="icon smaller-icon me-2" 
                                                src="/img/icons/avid-icons/clock.svg" 
                                                v-if="column.data_type == 'timestamp'"
                                                data-bs-toggle="tooltip" 
                                                title="Data type: Date & Time" alt=""
                                            >
                                        </div>

                                        <input 
                                            type="text" 
                                            class="form-control" 
                                            v-model="column.display_name" 
                                            readonly 
                                            v-if="!column.optional"
                                            :disabled="!if_allow_edit || ednaButtonDisabled[i]"
                                         aria-label="Text input">

                                        <accordion-select-with-list-header 
                                            v-else-if="column.destination_column == null || column.destination_column.indexOf('custom') == -1"
                                            v-model="column.destination_column" 
                                            :list_header_text="'Custom Column'"
                                            :options="getCurrentUnusedColumns(i, column)" 
                                            @editing="editing(column)" 
                                            @update:modelValue="selectDestinationColumn(i, column)"
                                            @listHeaderAction="selectCustomColumn(column)"
                                            :class="{'is-invalid' : errors.columns[i] && errors.columns[i].avid != ''}"
                                            :key="'destination-' + column.id"
                                            :id="'destination-' + column.id"
                                            :if_allow_edit="if_allow_edit && !ednaButtonDisabled[i]"
                                        ></accordion-select-with-list-header>

                                        <div class="input-group" v-else>
                                            <button 
                                                class="btn btn-secondary dropdown-toggle" 
                                                type="button" 
                                                data-bs-toggle="dropdown" 
                                                aria-expanded="false" 
                                                :id="'dropdown-'+ i"
                                                :class="{'is-invalid' : errors.columns[i] && errors.columns[i].avid && errors.columns[i].avid.indexOf('dropdown') != -1}" 
                                                ref="dropdown"
                                                @click="editing(column)"
                                                :disabled="!if_allow_edit || ednaButtonDisabled[i]"
                                            >
                                                {{( column.data_type == null ? "Data Type" : getPrettyDataType(column.data_type)) }}
                                            </button>

                                            <ul class="dropdown-menu dropdown-menu-primary dropdown-menu-start">
                                                <li><a class="dropdown-item" href="#" @click.prevent="setDataType(i, 'date')">Date</a></li>
                                                <li><a class="dropdown-item" href="#" @click.prevent="setDataType(i, 'timestamp')">Date & Time</a></li>
                                                <li><a class="dropdown-item" href="#" @click.prevent="setDataType(i, 'integer')">Integer</a></li>
                                                <li><a class="dropdown-item" href="#" @click.prevent="setDataType(i, 'numeric')">Decimal</a></li>
                                                <li><a class="dropdown-item" href="#" @click.prevent="setDataType(i, 'string')">Text</a></li>
                                                <li><a class="dropdown-item" href="#" @click.prevent="setDataType(i, 'boolean')">True / False</a></li>
                                            </ul>
                                            <input 
                                                type="text" 
                                                class="form-control" 
                                                placeholder="Column Name" 
                                                v-model="column.display_name" 
                                                :class="{'is-invalid' : errors.columns[i] && errors.columns[i].avid && errors.columns[i].avid.indexOf('name') != -1}"
                                                @change="columnExists(i, column.display_name)"
                                                :disabled="!if_allow_edit || ednaButtonDisabled[i]"
                                             aria-label="Text input">
                                        </div>
                                        <button 
                                            v-if="column.destination_column != null && column.destination_column.indexOf('custom') == -1"
                                            class="btn btn-secondary ms-2 me-1 btn-icon-only-md" 
                                            :class="{'is-generating': ednaButtonDisabled[i], 'generating-background': ednaButtonDisabled[i]}"
                                            data-bs-toggle="tooltip" 
                                            title="Suggest Mapping with Edna"
                                            @click="requestAISuggestion(column, i)"
                                            :disabled="!if_allow_edit || ednaButtonDisabled[i]"
                                        >
                                            <img class="icon" src="/img/icons/avid-icons/edna.svg" width="20" height="20" alt="">
                                        </button>
                                    </div>
                                    <div class="text-danger invalid-feedback" v-if="errors.columns[i] && errors.columns[i].avid != ''">
                                        {{errors.columns[i].avid }}
                                    </div>
                                </td>

                                <td class="mapping-grid__action" v-if="column.id!='custom_logic_temp_object'">
                                    <div>
                                        <button 
                                            v-if="column.optional && column.parent == null" 
                                            class="mapping-grid__button btn btn-warning btn-icon-only-md" 
                                            @click="removeColumn(i)"
                                            :disabled="!if_allow_edit"
                                        >
                                            <img class="icon" src="/img/icons/avid-icons/trash.svg" alt="">
                                        </button>

                                        <button 
                                            v-if="column.parent && column.class_names.includes('middle')" 
                                            class="mapping-grid__button btn btn-warning btn-icon-only-md" 
                                            @click="removeColumn(i)"
                                            :disabled="!if_allow_edit"
                                        >
                                            <img class="icon" src="/img/icons/avid-icons/trash.svg" alt="">
                                        </button>
                                    </div>
                                    <div data-bs-toggle="tooltip" title="This column mapping is required and cannot be removed.">
                                        <button 
                                            v-if="!column.optional && column.parent == null" 
                                            class="mapping-grid__button btn btn-warning btn-icon-only-md" 
                                            disabled
                                        >
                                            <img class="icon" src="/img/icons/avid-icons/trash.svg" alt="">
                                            <div class="strike-line"></div>
                                        </button>
                                    </div>
                                </td>

                                <transition name="slide">
                                    <tr class="custom-logic mb-2 pb-4 ms-2 me-0"
                                    v-if="column.source_column == 'CUSTOM' && (column.static_text == null || column.static_text == false) &&
                                        (column.editing || (errors.columns[i] && errors.columns[i].source && errors.columns[i].source.indexOf('logic') > -1))">
                                        <td :colspan="4" class="simplified-query-builder-wrapper p-0">
                                            <div class="card p-0">
                                                <div class="card-header">
                                                    <h4 class="mb-0"><i class="fas fa-sliders me-2"></i>Custom Logic</h4>
                                                </div>
                                                <div class="card-body p-0">
                                                    <div class="accordion" :id="'accordion-' + column.id" ref="accordion" >
                                                        <draggable handle=".handle" :list="column.column_logic.units" :element="'div'" :tag="'span'"  @end="onDragEnd" item-key="id" :disabled="!if_allow_edit">
                                                            <template #item="{element: unit, index: j}">
                                                                <div class="accordion-item border-top">
                                                                    <div class="d-flex align-items-center position-relative">
                                                                        <h1 class="accordion-header flex-grow-1 mb-0" :id="'heading-'+column.id+'-'+j">
                                                                            <button class="accordion-button py-3 d-flex align-items-center" type="button" data-bs-toggle="collapse" :data-bs-target="'#collapse-'+column.id+'-'+j"                                                                             :aria-expanded="(j==0 && (!errors.columns[i] || !errors.columns[i].source || errors.columns[i].source.indexOf('logic') == -1))?true:false"
                                                                            :class="{'collapsed' : (j > 0 || (errors.columns[i] && errors.columns[i].source && errors.columns[i].source.indexOf('logic') > -1))}">
                                                                                <span class="text-start flex-grow-1">
                                                                                    Output:
                                                                                    <em class="ms-1" v-if="column.data_type =='boolean' && (unit.value === true || unit.value === false)">{{ (unit.value === true) ? "Yes": "No" }}</em>
                                                                                    <em class="ms-1" v-else>
                                                                                        <span v-html="(unit.value_type == 'static' && unit.value != '') ? '&ldquo;' : ''"></span>{{ (unit.value == '') ? "(Not Set)" : getPrettyColName(unit.value) }}<span v-html="(unit.value_type == 'static' && unit.value != '') ? '&rdquo;' : ''"></span>
                                                                                    </em>
                                                                                </span>
                                                                            </button>
                                                                        </h1>
                                                                        <div class="d-flex gap-2 pe-3">
                                                                            <button class="btn btn-secondary btn-sm action handle" 
                                                                                data-bs-toggle="tooltip" data-placement="top" title="Move to Adjust Priority" 
                                                                                v-if="column.column_logic.units.length > 1" :disabled="!if_allow_edit" 
                                                                                @click.stop>
                                                                                <img src="/img/icons/avid-icons/drag-n-drop.svg" alt="drag" class="icon">
                                                                            </button>
                                                                            <button class="btn btn-secondary btn-sm action" 
                                                                                data-bs-toggle="tooltip" data-placement="top" title="Delete" 
                                                                                :disabled="!if_allow_edit" 
                                                                                @click.stop="removeLogicUnit($event, column, j)">
                                                                                <img src="/img/icons/avid-icons/trash.svg" alt="Delete" class="icon">
                                                                            </button>
                                                                            <button class="btn btn-secondary btn-sm action" 
                                                                                data-bs-toggle="tooltip" data-placement="top" title="Add Logic Unit" 
                                                                                :disabled="!if_allow_edit" 
                                                                                @click.stop="addLogicUnit($event, column, j, column.id, j)">
                                                                                <img src="/img/icons/avid-icons/plus.svg" alt="Add" class="icon">
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                    <div :id='"collapse-"+column.id+"-"+j' class="accordion-collapse collapse" :class="{'show' : (j==0 && (!errors.columns[i] || !errors.columns[i].source || errors.columns[i].source.indexOf('logic') == -1)) }" :data-bs-parent="'#accordion-' + column.id">
                                                                <div class="accordion-body pt-0">
                                                                    <div class="row mb-3">
                                                                        <div class="col">
                                                                            <query-builder-simplified
                                                                                :client="client"
                                                                                v-model="unit.logic"
                                                                                :static_db_columns="src_columns"
                                                                                :is_white="false"
                                                                                :ref="'simple-'+column.id+'-'+j"
                                                                                :source="source"
                                                                                :data_source_id="data_source_id"
                                                                                :key="'query-builder-'+unit.id"
                                                                                :if_allow_edit="if_allow_edit && !ednaButtonDisabled[i]"
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    <div class="d-flex flex-row align-items-center mt-3">
                                                                        <div class="col-md-4 col-12">Then, output value will be: </div>
                                                                        <div class="col-md-8 col-12">
                                                                            <div class="input-group">
                                                                                <button class="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false" :disabled="!if_allow_edit || ednaButtonDisabled[i]">{{ getValueTypeDisplay(unit.value_type) }}</button>
                                                                                <ul class="dropdown-menu dropdown-menu-primary dropdown-menu-start">
                                                                                    <li><a class="dropdown-item" @click.prevent="unit.value_type='column'">Column Value</a></li>
                                                                                    <li><a class="dropdown-item" @click.prevent="unit.value_type='sql'">SQL Value</a></li>
                                                                                    <li><a class="dropdown-item" @click.prevent="unit.value_type='static'">Static Value</a></li>
                                                                                </ul>

                                                                                <select v-if="column.data_type == 'boolean' && unit.value_type != 'column' && unit.value_type != 'sql'" class="form-control" placeholder="Value"
                                                                                    v-model="unit.value" :id="'unit-text-'+unit.id" @change="errors.columns[i] && errors.columns[i].logic && (errors.columns[i].logic[j]='')" :disabled="!if_allow_edit" aria-label="Value">
                                                                                    <option :value="true">Yes</option>
                                                                                    <option :value="false">No</option>
                                                                                </select>

                                                                                <input v-else-if="unit.value_type=='sql' || unit.value_type=='static'" type="text"
                                                                                    class="form-control" placeholder="Value" @change="sanitizeSQLStatement(i, j, unit)" :class="{'is-invalid' : errors.columns[i] && errors.columns[i].logic && errors.columns[i].logic[j] != null && errors.columns[i].logic[j] != ''}"
                                                                                    v-model="unit.value" :id="'unit-text-'+unit.id" :disabled="!if_allow_edit || ednaButtonDisabled[i]" aria-label="Text input">

                                                                                <accordion-select v-else-if="unit.value_type == 'column'" v-model="unit.value" :options="preview_column_array" @input="errors.columns[i] && errors.columns[i].logic && (errors.columns[i].logic[j] = '')"
                                                                                :class="{'is-invalid' : errors.columns[i] && errors.columns[i].logic && errors.columns[i].logic[j] != null && errors.columns[i].logic[j] != ''}" :if_allow_edit="if_allow_edit && !ednaButtonDisabled[i]"></accordion-select>
                                                                            </div>
                                                                            <div class="text-danger invalid-feedback" v-if="errors.columns[i] && errors.columns[i].logic && errors.columns[i].logic[j] != null && errors.columns[i].logic[j] != ''">
                                                                                {{errors.columns[i].logic[j]}}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </draggable>

                                                <div class="accordion-item border-top">
                                                    <div class="d-flex align-items-center position-relative">
                                                        <h1 class="accordion-header flex-grow-1 mb-0" :id="'default-'+column.id">
                                                            <button class="accordion-button py-3 collapsed d-flex align-items-center" type="button" data-bs-toggle="collapse" :data-bs-target="'#collapse-'+column.id+'-default'" aria-expanded="false">
                                                                <span class="text-start flex-grow-1">
                                                                    Default Output:
                                                                    <em class="ms-1" v-if="column.data_type =='boolean' && (column.column_logic.default_value === true || column.column_logic.default_value === false)">
                                                                        {{ (column.column_logic.default_value === true) ? "Yes": "No" }}
                                                                    </em>
                                                                    <em class="ms-1" v-else-if="column.column_logic.default_type=='column'">
                                                                        {{ (column.column_logic.default_value == '') ? "(Not Set)" : 
                                                                        propercase((column.column_logic.default_value && typeof column.column_logic.default_value == 'object' && column.column_logic.default_value.text) ? 
                                                                        column.column_logic.default_value.text : (column.column_logic.default_value || '')) }}
                                                                    </em>
                                                                    <em class="ms-1" v-else>
                                                                        <span v-html="(column.column_logic.default_type == 'static'  && column.column_logic.default_value != '') ? '&ldquo;' : ''"></span>{{ (column.column_logic.default_value == '') ? "(Not Set)" : column.column_logic.default_value }}<span v-html="(column.column_logic.default_type == 'static' && column.column_logic.default_value != '') ? '&rdquo;' : ''"></span>
                                                                    </em>
                                                                </span>
                                                            </button>
                                                        </h1>
                                                        <div class="d-flex gap-2 pe-3">
                                                            <button class="btn btn-secondary btn-sm action" 
                                                                data-bs-toggle="tooltip" data-placement="top" title="Add Logic Unit" 
                                                                :disabled="!if_allow_edit" 
                                                                @click.stop="addLogicUnit($event, column, column.column_logic.units.length, column.id, 'default')">
                                                                <img src="/img/icons/avid-icons/plus.svg" alt="Add" class="icon">
                                                            </button>
                                                        </div>
                                                    </div>

                                                    <div :id="'collapse-'+column.id+'-default'" class="accordion-collapse collapse"  :data-bs-parent="'#accordion-'+ column.id">
                                                        <div class="accordion-body pt-0">
                                                            <div class="flex-row d-flex">
                                                                <span class="col-md-6 col-12">When none of cases above are met, output value will be: </span>
                                                                <div class="col-md-6 col-12">
                                                                    <div class="input-group" >
                                                                        <button class="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false" :disabled="!if_allow_edit || ednaButtonDisabled[i]">
                                                                            {{ getValueTypeDisplay(column.column_logic.default_type)}}
                                                                        </button>
                                                                        <ul class="dropdown-menu dropdown-menu-primary dropdown-menu-start">
                                                                            <li><a class="dropdown-item" @click.prevent="column.column_logic.default_type='column'">Column Value</a></li>
                                                                            <li><a class="dropdown-item" @click.prevent="column.column_logic.default_type='sql'">SQL Value</a></li>
                                                                            <li><a class="dropdown-item" @click.prevent="column.column_logic.default_type='static'">Static Value</a></li>
                                                                        </ul>
                                                                        <select v-if="column.data_type == 'boolean' && column.column_logic.default_type == 'static'" class="form-control" placeholder="Value"
                                                                            v-model="column.column_logic.default_value" :id="'unit-text--default-'+column.id"  @change="column.column_logic.default_value_error=''" :disabled="!if_allow_edit" aria-label="Value">
                                                                            <option :value="true">Yes</option>
                                                                            <option :value="false">No</option>
                                                                        </select>

                                                                        <input v-else-if="column.column_logic.default_type != 'column'" type="text"
                                                                            class="form-control" placeholder="Value"
                                                                            v-model="column.column_logic.default_value" id='unit-text-default' :disabled="!if_allow_edit || ednaButtonDisabled[i]" aria-label="Value">

                                                                        <accordion-select v-else  v-model="column.column_logic.default_value" :options="preview_column_array" :if_allow_edit="if_allow_edit"></accordion-select>

                                                                        <button v-if="column.column_logic.default_type=='sql'" class="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false" :disabled="!if_allow_edit || ednaButtonDisabled[i]">Columns</button>
                                                                        <ul v-if="column.column_logic.default_type=='sql'" class="dropdown-menu dropdown-menu-primary dropdown-menu-end">
                                                                            <li><a class="dropdown-item" v-for="(col_name, key) in src_columns" @click="addColumnToText('default', key)" :disabled="!if_allow_edit">{{col_name}}</a></li>
                                                                        </ul>
                                                                    </div>
                                                                    <div class="text-danger invalid-feedback" v-if="column.column_logic.default_value_error != ''">
                                                                        {{column.column_logic.default_value_error }}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                                </div>
                                        </td>
                                    </tr>
                                </transition>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="d-none d-xl-block drill-down mb-3" :class="(is_expanded ? 'col-12' : 'col-4')">
                <div :class="{ 'sticky-top': is_sticky }" ref="stickyDiv">
                    <div class="card table-card mb-2" v-for="index in depth" :key="index">
                        <div class="card-body px-0" :class="{'py-0': depth != index}">
                            <div class="row" v-if="depth == index">
                                <div class="col mx-3 mb-3">
                                    <label class="form-label ">Column to Preview</label>
                                    <accordion-select v-model="preview_table_val[index-1]" :options="preview_column_array"
                                    @update:modelValue="updatePreviewTable(preview_table_val[index-1])"></accordion-select>
                                </div>
                            </div>
                            <p v-if="preview_table_val[index-1] != null && depth == 1" class="mx-3 mb-2">The table below represents the number of records for each of the top 10 values for the given column. Drill deeper into the data or view a preview using the icons below.</p>
                            <p v-if="depth < 2 && isIncrementalFile()" class="mx-3 mb-2"><em>For "Append" refresh types, this preview is limited to data from the first file uploaded.</em></p>
                            <div class="table-width-responsive  overflow-auto" style="max-height: 300px;" >
                                <!-- <div class="overflow-hidden rounded-top" v-if="depth != index"><div class="p-1 bg-dark"></div></div> -->
                                <table class="table table-without-pagination gy-0 mx-0 my-2" v-if="preview_table_val[index-1] != null">
                                    <thead>
                                        <tr>
                                            <th class='ps-3' ><p>{{ propercase(mirrorAccordionSelectStyle(preview_table_val[index-1]))}} </p></th>
                                            <th ><p>Records</p></th>
                                            <th style="width:70px;"><p>Actions</p></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="preview_table[index-1] == null">
                                            <td colspan="3" class="text-center p-2"><div class="d-inline-block spinner-border spinner-border-sm ms-2" role="status"></div> Loading</td></tr>
                                        <tr v-else-if="preview_table[index-1].length == 0">
                                            <td colspan="3" class="text-center"><strong><em>No records were found for the given column.</em></strong></td></tr>

                                        <tr v-for="(f, row_num) in getFilteredPreviewRows(index-1)" :key="f.name">
                                            <td class='ps-3 align-middle ' v-if="f.name != null && f.name != ''">
                                                {{f.name}}
                                            </td>
                                            <td class='ps-3 align-middle ' v-else>
                                                <em>null</em>
                                            </td>
                                            <td class="align-middle ">{{ number_with_zero(f.count) }}</td>
                                            <td class="text-nowrap" >
                                                <button type="button" class="btn btn-sm btn-none p-2 me-1" v-if="depth == index" @click="previewRecords(f.name)">
                                                    <i class="fa fa-eye"  v-if="preview_detail_loading != f.name || (f.name == '')" data-bs-toggle="tooltip" data-placement="top"  title="Preview" ></i>
                                                    <div class="spinner-border  spinner-border-sm" role="status" v-else></div>
                                                </button>
                                                <button type="button" class="btn btn-sm btn-none p-2" v-if="depth == 1" @click="drilldown(row_num, f.name)" >
                                                    <i class="fas fa-arrow-down" data-bs-toggle="tooltip" data-placement="top"  title="Drill Down"></i>
                                                </button>
                                                <button type="button" class="btn btn-sm btn-none p-2" v-if="depth == 2 && index == 1" @click="removeDrilldown()">
                                                    <i class="fas fa-close" data-bs-toggle="tooltip" data-placement="top" title="Remove Drill Down"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 d-flex">
                <button v-if="if_allow_edit" class="btn btn-secondary" @click="addColumn()" ><i class="fas fa-plus"></i> Add Column</button>
                <div v-else class="d-inline-block" data-bs-toggle="tooltip" title="You do not have privileges to complete this action">
                    <button class="btn btn-secondary" :disabled="true"><i class="fas fa-plus"></i> Add Column</button>
                </div>
                <button v-if="if_allow_edit" class="btn btn-secondary ms-3" @click="addAllColumns()" ><i class="fas fa-table-columns"></i> Add All Source Columns</button>
                <div v-else class="d-inline-block" data-bs-toggle="tooltip" title="You do not have privileges to complete this action">
                    <button class="btn btn-secondary ms-3" :disabled="true"><i class="fas fa-table-columns"></i> Add All Source Columns</button>
                </div>
            </div>
        </div>

        <div class="modal fade column-mapping-preview-modal" :id="'column-mapping-preview-' +data_source_id"
            aria-labelledby="column-mapping-preview" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content bg-white" v-if="preview_detail_table.length > 0">
                    <div class="modal-header">
                        <div class="d-flex align-items-start w-100">
                            <h5 class="modal-title mb-0">Preview</h5>
                            <div class="d-flex align-items-center">
                                <button type="button" class="btn btn-white close-modal" data-bs-dismiss="modal" @click="preview_detail_index=0" data-bs-toggle="tooltip" title="Close">
                                    <img class="icon" src="/img/icons/avid-icons/close.svg" alt="">
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body pt-0">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <div class="fw-semibold">Sample {{ preview_detail_index + 1 }} of {{ preview_detail_table.length }}</div>
                            <div class="d-flex align-items-center gap-2">
                                <button class="btn btn-secondary btn-icon-only-sm" :disabled="preview_detail_index === 0" @click="preview_detail_index--">
                                    <i class="fas fa-chevron-left"></i>
                                </button>
                                <button class="btn btn-secondary btn-icon-only-sm" :disabled="preview_detail_index >= preview_detail_table.length - 1" @click="preview_detail_index++">
                                    <i class="fas fa-chevron-right"></i>
                                </button>
                            </div>
                        </div>
                        <div class="table-card table-width-responsive p-0">
                            <table class="table table-without-pagination table-striped mb-0">
                                <thead class="table-primary">
                                    <tr>
                                        <th class="ps-3">Column Name</th>
                                        <th>Column Value</th>
                                    </tr>
                                </thead>
                                <tbody class="table-striped">
                                    <tr v-for="(value, colIndex) in Object.values(preview_detail_table[preview_detail_index])" v-if="getPrettyColNameByIndex(colIndex).indexOf('_') !== 0">
                                        <td class="ps-3">{{getPrettyColNameByIndex(colIndex)}}</td>
                                        <td>{{value}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="modal-content bg-white" v-else>
                    <div class="modal-header">
                        <div class="d-flex align-items-start w-100">
                            <h5 class="modal-title mb-0">Preview</h5>
                            <div class="d-flex align-items-center">
                                <button type="button" class="btn btn-white close-modal" data-bs-dismiss="modal" @click="preview_detail_index=0" data-bs-toggle="tooltip" title="Close">
                                    <img class="icon" src="/img/icons/avid-icons/close.svg" alt="">
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body">
                        <h3>No records were found for the given column.</h3>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <!-- Column Mapping Proposal Modal -->
    <ColumnMappingProposalModal
        v-if="proposalModalData"
        :key="proposalModalKey"
        :client="client"
        :data-set-id="proposalModalData.data_set_id"
        :column-mapping-id="proposalModalData.column_mapping_id"
        :column-mapping-suggestion-id="proposalModalData.column_mapping_suggestion_id"
        :file-id="proposalModalData.file_id"
        :destination-column="proposalModalData.destination_column"
        :previous-response-id="proposalModalData.previous_response_id"
        :proposal="proposalModalData.proposal"
        :reasoning="proposalModalData.reasoning"
        :source="source"
        :data-source-id="data_source_id"
        @accepted="handleProposalAccepted"
        ref="proposalModal"
    />
</template>
<script>
import draggable from 'vuedraggable';
import Swal from 'sweetalert2';
import { useNotifications } from '../../composables/useNotifications';
import { useAISuggestionPolling, createFileCheckFunction, createDataSetColumnCheckFunction, createColumnMappingSuggestionCheckFunction } from '../../composables/useAISuggestionPolling';
import ColumnMappingProposalModal from './ColumnMappingProposalModal.vue';

export default {
    components: {
        draggable,
        Swal,
        ColumnMappingProposalModal
    },
    props: {
        id: {
            type: String,
            default: null
        },
        client: {
            type: Object,
        },
        modelValue: {
            type: Array,
            default: () => []
        },
        dest_columns: {
            default: () => []
        },
        dataset: { type: Object },
        source: {default: 'file' },
        data_source_id: {default: null },
        if_allow_edit: {
            type: Boolean,
            default: true
        }
    },
    emits: ['update:modelValue'],
    data() {
        return {
            mapping: [],
            depth: 1,
            drill_index: null,
            preview_table_val: [],
            preview_table_logic: [],
            preview_table: [],
            preview_table_data_type: [], // Add this line to store data_type for each preview level
            preview_detail_table: [],
            preview_detail_index: 0,
            preview_detail_loading: "",
            src_columns: null,
            src_column_array: null,
            preview_column_array: null, // preview_column_array is basically src_column_array without custom logic option at the end
            local_dest_columns: [],
            flat_dest_columns: [],
            unused_dest_columns: [],
            errors: {
                columns: []
            },
            is_sticky: false,
            is_expanded: false,
            tooltipList: [],
            tooltipCleanupInterval: null,
            ednaButtonDisabled: {},
            proposalModalData: null,
            proposalModalKey: 0,
            isProcessingProposal: false,
            temporaryColumnMappingIds: [], // Track column definitions created for suggestions that haven't been saved
            temporarySuggestionIds: [], // Track suggestion-only rows (no column definition yet) for cleanup on unmount
            hasBeenSaved: false // Track whether the parent component has successfully saved
        };
    },
    beforeMount() {
        this.local_dest_columns = JSON.parse(JSON.stringify(this.dest_columns));
        this.setupScreen();
    },
    created() {
        window.addEventListener('scroll', this.handleScroll);
        // Initialize notifications composable
        const { showNotification } = useNotifications();
        this.showNotification = showNotification;
        
        // Initialize polling composable for fallback
        const polling = useAISuggestionPolling();
        this.startPolling = polling.startPolling;
        this.stopPolling = polling.stopPolling;
        this.isPolling = polling.isPolling;
        
        // Listen for custom event to open proposal modal - add in created() so it's available even if component isn't fully mounted
        window.addEventListener('openColumnMappingProposal', this.handleOpenProposalModal);
        window.addEventListener('openFileMappingProposal', this.handleOpenFileProposalModal);
        
        // Listen for re-enabling suggestion buttons on validation failure
        window.addEventListener('reEnableSuggestion', this.handleReEnableSuggestion);
    },
    mounted() {
       // Check if there's a pending proposal action when component mounts
        if (window.__pendingColumnMappingProposal) {
            const pendingAction = window.__pendingColumnMappingProposal;
            
            // Check if it's for this component's dataset
            if (!pendingAction.data_set_id || pendingAction.data_set_id === this.data_source_id) {
                this.handleOpenProposalModal({ detail: pendingAction });
                // Clear the pending action
                delete window.__pendingColumnMappingProposal;
            }
        }
        
        // Check if there's a pending file proposal action when component mounts
        if (window.__pendingFileMappingProposal) {
            const pendingAction = window.__pendingFileMappingProposal;
            
            // Check if it's for this component's file
            if (pendingAction.file_id && parseInt(pendingAction.file_id) === parseInt(this.data_source_id) && this.source === 'file') {
                this.handleOpenFileProposalModal({ detail: pendingAction });
                // Clear the pending action
                delete window.__pendingFileMappingProposal;
            }
        }
    },
    unmounted() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('openColumnMappingProposal', this.handleOpenProposalModal);
        window.removeEventListener('openFileMappingProposal', this.handleOpenFileProposalModal);
        window.removeEventListener('reEnableSuggestion', this.handleReEnableSuggestion);
    },
    // computed: {
    //     src_columns_sorted() {
    //         const keys = Object.keys(this.src_columns);
    //         keys.sort();
    //         const obj = {};
    //         for(const i in keys) {
    //             //Split the this.src_columns[keys[i]] string based upon . and then rejoin with a :
    //             let col_name = this.src_columns[keys[i]];
    //             if(keys[i].indexOf(".") != -1) {
    //                 const split = keys[i].split(".", 2);
    //                 col_name = this.propercase(split[0].trim()) + ": " + this.propercase(split[1].trim());
    //             }
    //             obj[keys[i]] = col_name;
    //         }
    //         return obj;
    //     }
    // },
    mounted() {
        this.initTooltips();

        const innerButtons = document.querySelectorAll('.action');

        innerButtons.forEach(button => {
            button.addEventListener('mouseenter', () => {
                const accordionButton = button.parentElement;
                accordionButton.setAttribute('data-bs-toggle', '');
            });

            button.addEventListener('mouseleave', () => {
                const accordionButton = button.parentElement;
                accordionButton.setAttribute('data-bs-toggle', 'collapse');
            });
        });

        // Add global tooltip management
        document.addEventListener('mouseover', this.handleGlobalTooltipManagement);
        
        // Set up periodic tooltip cleanup to prevent accumulation
        this.tooltipCleanupInterval = setInterval(() => {
            this.forceHideAllTooltips();
        }, 5000); // Clean up every 5 seconds
    },
    beforeUnmount() {
        // Ensure all tooltips are destroyed when component is unmounted
        this.destroyTooltips();
        
        // Remove global event listener
        document.removeEventListener('mouseover', this.handleGlobalTooltipManagement);
        
        // Clear the tooltip cleanup interval
        if (this.tooltipCleanupInterval) {
            clearInterval(this.tooltipCleanupInterval);
        }
        
        // Reject any temporary column definitions that haven't been saved
        if (!this.hasBeenSaved && this.temporaryColumnMappingIds.length > 0) {
            const columnsToReject = this.mapping.filter(column =>
                this.temporaryColumnMappingIds.includes(column.id) &&
                (!column.source_column || column.source_column === '') &&
                (!column.column_logic || (Array.isArray(column.column_logic) && column.column_logic.length === 0))
            );
            columnsToReject.forEach(column => {
                if (column.id && column.id > 0) {
                    window.axios.post(`/api/column-mapping/${this.client.url}/reject`, {
                        column_mapping_id: column.id
                    }).catch(error => {
                        console.error('Error rejecting temporary column definition:', error);
                    });
                }
            });
        }
        // Reject suggestion-only rows (no column definition was ever created)
        if (!this.hasBeenSaved && this.temporarySuggestionIds.length > 0) {
            this.temporarySuggestionIds.forEach(suggestionId => {
                window.axios.post(`/api/column-mapping/${this.client.url}/reject`, {
                    column_mapping_suggestion_id: suggestionId
                }).catch(error => {
                    console.error('Error rejecting temporary suggestion:', error);
                });
            });
        }
    },
    watch: {
        data_source_id() {
            this.setupScreen();
        },
        dest_columns(){
            this.local_dest_columns = JSON.parse(JSON.stringify(this.dest_columns));
            this.setupScreen();
        },
        modelValue: {
            handler(newVal) {
                if (!newVal || (newVal && newVal.length == 0)) {
                    this.getDefaultMapping();
                } else {
                    if (newVal !== this.mapping) {
                        this.mapping = newVal;
                    }
                }
            },
            deep: true
        },
        mapping: {
            handler(newVal) {
                // Ensure errors.columns array is in sync with mapping array
                while(this.errors.columns.length < newVal.length) {
                    this.errors.columns.push({
                        source: "",
                        avid: "",
                        logic: []
                    });
                }
                while(this.errors.columns.length > newVal.length) {
                    this.errors.columns.pop();
                }
                this.$emit('update:modelValue', newVal);
            },
            deep: true
        },
        'dataset.joins': {
            handler() { this.setupScreen(); },
            deep: true
        }
    },
    methods: {
        formatSourceColumn(sourceColumn) {
            if (!sourceColumn) return 'Custom Logic';
            return sourceColumn
                .replace(/_/g, ' ')
                .replace(/\./g, ' > ')
                .replace(/\b\w/g, char => char.toUpperCase());
        },
        setupScreen(){
            //Set the default value for the src columns and the filter
            this.src_column_array = this.getSourceColumnArray();
            //Src_columns use to be this.dataset.source_columns but we need to swap it for the scr_column_array data since it contains the join
            //Loop through the src_column array, starting at position 1, and add the columns with value being the key and text being hte value
            this.src_columns = {};
            for(var i = 1; i < this.src_column_array.length; i++) {
                this.src_columns[this.src_column_array[i].value] = this.src_column_array[i].text;
            }
            this.preview_column_array = this.src_column_array.slice(1); // remove the custom logic option from preview option list

            //Set the destination columns into a flat array
            // Clear existing flat_dest_columns to prevent accumulation when setupScreen runs multiple times
            this.flat_dest_columns = [];
            for(var i = 0; i < this.local_dest_columns.length; i++) {
                if(this.local_dest_columns[i].type == 'array') {
                    for(var j = 0; j < this.local_dest_columns[i].columns.length; j++) {
                        this.flat_dest_columns.push(this.local_dest_columns[i].columns[j]);
                        this.flat_dest_columns[this.flat_dest_columns.length-1].parent_index = i
                    }
                }
                else
                    this.flat_dest_columns.push( this.local_dest_columns[i]);
            }

            //Set the default columns or whatever was sent to me
            if(this.modelValue != null) {
                this.mapping = this.setColumnDetails(this.modelValue);
                this.mapping.forEach(m => {
                    m.editing = false;
                    //If it is the static value, set those values too
                    if(m.source_column == 'CUSTOM' && m.column_logic.units.length == 0 && m.column_logic.default_type == 'static') {
                        m.static_text = true;
                        m.static_text_value = m.column_logic.default_value;
                    }
                });

                //get the default mapping too and make sure it is in the provided mapping
                var default_mapping = this.getDefaultMapping();
                for(var i = 0; i < default_mapping.length; i++) {
                    var found = false;
                    for(var j = 0; j < this.mapping.length; j++) {
                        if(this.mapping[j].destination_column == default_mapping[i].destination_column) {
                            found = true;
                            break;
                        }
                    }
                    if(!found) {
                        //Add it to the top of the array
                        this.mapping.unshift(default_mapping[i]);
                    }
                }
            }
            else
                this.mapping = this.getDefaultMapping();

            this.getUnusedDestinationColumns();

            // console.log(this.mapping);
            //For the error message, set the default value to false.
            // Clear existing errors first to prevent accumulation when setupScreen runs multiple times
            this.errors.columns = [];
            for(var i = 0; i < this.mapping.length; i++) {
                //Need to establish this before I set errors in the case of removed columns (logic below)
                this.errors.columns.push({
                    source: "",
                    avid: "",
                    logic: []
                });

                //Determine if the source columns mapped are in the latest data upload (stored in the src_columns variable)
                if( this.mapping[i].source_column == "CUSTOM" ) {
                    //Save placeholders for the error messages
                    this.errors.columns[this.errors.columns.length-1].logic = new Array(this.mapping[i].column_logic.units.length);

                    //This function should show the right error if there is one
                    var no_errors = this.isUnitValid(i, this.mapping[i].column_logic.units);
                    if (!no_errors) {
                        this.mapping[i].editing = true;
                    }
                    //If it is a column that was removed...
                    if(no_errors && this.mapping[i].column_logic && this.mapping[i].column_logic.default_type == 'column') {
                        var default_value = this.mapping[i].column_logic.default_value;
                        var column_key = (default_value && typeof default_value == 'object' && default_value.value) ? default_value.value : default_value;
                        if(column_key && this.src_columns[column_key] == null) {
                            this.errors.columns[this.errors.columns.length-1].source = 'A column used in the logic below has been removed from the latest data refresh.';
                        }
                    }
                }
                else if(this.mapping[i].source_column != null && this.mapping[i].source_column != ""  && this.src_columns[this.mapping[i].source_column] == null )
                    this.errors.columns[this.errors.columns.length-1].source = "A column (" + this.mapping[i].source_column + ") has been removed from the latest data refresh. Please update this field.";
            }

            // Re-initialize tooltips after the component is updated
            this.$nextTick(() => {
                this.initTooltips();
            });
        },
        isIncrementalFile() {
            if(this.dataset.settings == null || !this.dataset.settings['refresh_type']) return false;

            if(this.dataset.settings['refresh_type'] == 'incremental' && this.dataset.settings['ignore_unused'] != null && this.dataset.settings['ignore_unused'] === true)
                return true;

            return false;
        },
        mirrorAccordionSelectStyle(value) {
            //If it contains a ., then replace it with a : and a space and then propercase all the words
            if (!value) return '';
            let val = value.value || value;
            if(val && typeof val === 'string' && val.indexOf(".") != -1) {
                var split = val.split(".", 2);
                return this.propercase(split[0].trim()) + ": " + this.propercase(split[1].trim());
            }
            return val || '';
        },
        getSourceColumnArray() {
            let arr = [{
                value: 'CUSTOM',
                text: 'Custom Logic',
                category: 'list-header'
            }];
            arr = arr.concat(this.getColumnArray(this.dataset.source_columns));
            if(this.dataset.joins && this.dataset.joins.length > 0){
                for(let i = 0; i < this.dataset.joins.length; i++){
                    //If the joined data set is null, skip it
                    if(this.dataset.joins[i].joined_data_set == null || this.dataset.joins[i].joined_data_set.columns == null) continue;

                    let cols = this.dataset.joins[i].joined_data_set.columns;
                    //Skip the first one since it is the custom column mapping option
                    for(let j = 1; j < cols.length; j++){
                        let col = cols[j].value;
                        if (col == null || typeof col !== 'string') continue;
                        //Remove all text before the last .
                        col = col.substring(col.lastIndexOf('.')+1);
                        //Append the dataset join name but replace all space with a _ and make lowercase
                        //Also remove all non-alphanumeric characters
                        col = this.dataset.joins[i].name.replace(/ /g, "_").replace(/[^a-zA-Z0-9_.]/g, '').toLowerCase() + "_." + col;
                        arr.push({
                            value: col,
                            text: cols[j].display_name,
                            category: this.dataset.joins[i].name
                        });
                    }
                }
            }

            return arr;
        },
        getColumnArray(src_columns) {
            var columns = [];
            //Sort the this.src_columns
            var keys = src_columns ? Object.keys(src_columns) : [];
            //sort keys but, if it has a period in the name, it should be lower than works without a period
            keys.sort(function(a, b) {
                if(a.indexOf(".") == -1 && b.indexOf(".") != -1)
                    return -1;
                else if(a.indexOf(".") != -1 && b.indexOf(".") == -1)
                    return 1;
                else
                    return a.localeCompare(b);
            });

            for(var i in keys) {
                let key = keys[i];
                let text = src_columns[key];
                let category = null;

                //If the key contains a .
                if(key.indexOf(".") != -1) {
                    //split string by . , separate any structs that are 3+ layers deep with a > in between
                    var split = key.split(".");
                    category = this.propercase(split[0]);
                    text = this.propercase(split.slice(1).join(' > '));
                }

                columns.push({
                    value: key,
                    text: text,
                    category: category
                });
            }

            return columns;
        },
        handleScroll() {
            if(this.$refs.stickyDiv == null) return;

            const divTop = this.$refs.stickyDiv.getBoundingClientRect().top;
            this.is_sticky = divTop <= 0;
        },
        getMappingClass(err, column) {
            var c = '';
            if(column && column.class_names != null)
                c = column.class_names;

            if(err && (err.source != '' || err.avid != ''))
                c += " is-invalid";

            return c;
        },
        onDragEnd(e) {
            //If they moved it...
            if(e.newIndex != e.oldIndex) {
                let show_pos = -1;

                //Get the ide of the currently open accordion item
                var open_item =document.querySelector('.accordion-collapse.show');
                if(open_item == null) return;

                var open = document.querySelector('.accordion-collapse.show')
                var open_pos = open.id.substring(open.id.indexOf('-')+1);
                var new_index = open_pos.substring(open_pos.indexOf('-')+1);

                //If the open one was the one that was moved

                if(parseInt(new_index) == e.oldIndex) {
                    show_pos = open_pos.substring(0, open_pos.indexOf('-')+1) + e.newIndex;
                }

                //If it needs to be toggled
                else if(parseInt(new_index) >= e.newIndex &&  parseInt(new_index) <= e.oldIndex || parseInt(new_index) <= e.newIndex &&  parseInt(new_index) >= e.oldIndex) {
                    show_pos = parseInt(new_index) + ((e.newIndex > e.oldIndex) ? -1 : 1);
                    show_pos = open_pos.substring(0, open_pos.indexOf('-')+1) + show_pos;
                }

                this.$nextTick(() => {
                    //Hide the open one
                    if (document.getElementById('collapse-' + open_pos)){
                        document.getElementById('collapse-' + open_pos).classList.remove('show');
                        document.querySelector('#heading-' + open_pos + ' .accordion-button').classList.add('collapsed');
                    }
                    //Show it without the annimations
                    if (document.getElementById('collapse-' + show_pos)){
                        document.getElementById('collapse-' + show_pos).classList.add('show');
                        document.querySelector('#heading-' + show_pos + ' .accordion-button').classList.remove('collapsed');
                    }
                });
            }
        },
        getValueTypeDisplay(type) {
            if(type == 'sql')
                return 'SQL Value';
            if(type == 'column')
                return 'Column Value';

            return 'Static Value';
        },
        getPrettyDataType(type) {
            if(type == 'boolean')
                return 'True / False';
            if(type == 'date')
                return 'Date';
            if(type == 'timestamp')
                return 'Date & Time';
            if(type == 'integer')
                return 'Integer';
            if(type == 'numeric')
                return 'Decimal';
            if(type == 'string')
                return 'Text';

            return "Unknown";
        },
        getPrettyColNameByIndex(index) {
            var name = Object.keys(this.preview_detail_table[this.preview_detail_index])[index];
            return this.getPrettyColName(name);
        },
        getPrettyColName(name) {
            var name_text = name && typeof name == 'object' ? name.text : name;
            var cols = Object.keys(this.src_columns);
            for(var i = 0; i < cols.length; i++) {
                if(cols[i] == name_text){
                    let value = Object.values(this.src_columns)[i];
                    if(value.indexOf(".") != -1) {
                        let split = value.split(".", 2);
                        return this.propercase(split[0].trim()) + ": " + this.propercase(split[1].trim());
                    }
                    return value;
                }
            }

            return this.propercase(name_text);
        },
        setColumnDetails(val) {
            //Copy the map array as a deep copy
            var map = JSON.parse(JSON.stringify(val));
            var parent = null;
            var index = 0;

            //Determine if it is missing adjointing columns for email, phone, or address.
            map = this.removeDupeColumns(map);
            map = this.addMissingColumns(map);

            for(var i = 0; i < map.length; i++) {
                var col = this.flat_dest_columns.find(c => c.column == map[i].destination_column);
                if(col != null){
                    map[i].optional = col.optional;
                    //The autogenerated columns will have null for this so we need to give it a default value
                    if(map[i].column_logic == null)
                        map[i].column_logic = {
                            units: [this.getUnit()],
                            default_value: '',
                            default_type: 'static',
                            default_value_error: ''
                        }
                    //if it is part of an array
                    if(col.parent_index != null){

                        //The first element should be optional, all of the others aren't
                        // (This is because "optional" means they aren't required either in this case. It is mainly to achieve the visual I needed)
                        if(index != 0 && index != cols.length)
                            map[i].optional = false;

                        var cols = this.local_dest_columns[col.parent_index].columns;
                        var middle_index = this.findMiddleIndex(cols);

                        map[i].parent = this.local_dest_columns[col.parent_index].column;
                        map[i].class_names = 'is-'+this.local_dest_columns[col.parent_index].column;
                        //If it doesn't have a parent, the parent type is different, or it has counted
                        // the total number of columns in the set. (This handles when there are multiple
                        // emails or phones together)
                        if(parent == null || parent != map[i].parent || index == cols.length) {
                            map[i].class_names += " first";
                            //If I was in an array in the last iteration...
                            if(parent != null && parent != map[i].parent|| index == cols.length) {
                                map[i-1].class_names += " last";
                                index = 0;
                            }

                            parent = map[i].parent;
                        }

                        else if(index == middle_index)
                            map[i].class_names += " middle";

                        index++;

                    }
                    //If I'm not in an array but I was previously
                    else if (parent != null) {
                        parent = null;
                        map[i-1].class_names += " last";
                        index = 0;
                    }
                }

                else {
                    map[i].optional = true;
                    //If it is a custom defined column and it was in an array
                    if (parent != null) {
                        parent = null;
                        map[i-1].class_names += " last";
                        index = 0;
                    }
                }
            }
            //Make sure I didn't end in an array
            if (parent != null) {
                map[map.length-1].class_names += " last";
            }
            return map;
        },
        removeDupeColumns(map) {
            //Some of the old data may have resulted in duplicate columns from an array existing. Need to remove them on load
            for(var i = 0; i < map.length; i++) {
                var col = this.flat_dest_columns.find(c => c.column == map[i].destination_column);
                //This only applies to columns that are part of an array
                if(col != null && col.parent_index != null){
                    var cols = this.local_dest_columns[col.parent_index].columns;
                    //All of the cols need to be in the next cols.length-1 positions in map
                    for(var j = 0; j < cols.length; j++) {
                        let existing_column = [];
                        for(var k = i; k < Math.min(i+cols.length, map.length); k++) {
                            if(map[k].destination_column == cols[j].column) {
                                if(existing_column.includes(map[k].destination_column)){
                                    map.splice(k, 1);
                                    k--;
                                }
                                else
                                    existing_column.push(map[k].destination_column);
                                break;
                            }
                        }
                    }
                    i += cols.length-1;
                }
            }

            return map;
        },
        addMissingColumns(map) {
            //Determine if it is missing adjointing columns for email, phone, or address.
            for(var i = 0; i < map.length; i++) {
                var col = this.flat_dest_columns.find(c => c.column == map[i].destination_column);
                if(col != null && col.parent_index != null){
                    let added = 0;
                    var cols = this.local_dest_columns[col.parent_index].columns;
                    //All of the cols need to be in the next cols.length-1 positions in map
                    for(var j = 0; j < cols.length; j++) {
                        var found = false;
                        for(var k = i; k < Math.min(i+cols.length, map.length); k++) {
                            if(map[k].destination_column == cols[j].column) {
                                found = true;
                                break;
                            }
                        }
                        if(!found) {
                            var new_map = this.getMap(cols[j]);
                            map.splice(i+1, 0, new_map);
                            added++;
                        }
                    }

                    if(added > 0) {
                        //Check those columns to make sure at least one of them has a value
                        var has_value = false;
                        for(var j = i; j < i+cols.length; j++) {
                            if(map[j].source_column != null && map[j].source_column != '') {
                                has_value = true;
                                break;
                            }
                        }
                        //If they are all empty, need to remove the array
                        if(!has_value) {
                            map.splice(i, cols.length);
                            i--;
                        }
                        else
                            i += cols.length-1;
                    }
                    else i += cols.length-1;

                }
            }

            return map;
        },
        getUnusedDestinationColumns(){
            var unused_dest_columns = [...this.flat_dest_columns];
            this.mapping.forEach((mapping) => {
                var index = unused_dest_columns.findIndex((col) => mapping.destination_column == col.column && (col.parent_index == null || col.parent_index == undefined));
                if (index >=0){
                    unused_dest_columns.splice(index, 1);
                }
            });
            unused_dest_columns.forEach((column) => {
                column.category = null;
                column.text = column.name;
                column.value = column.column;
            });

            this.unused_dest_columns = unused_dest_columns;
            this.$forceUpdate();
        },
        getCurrentUnusedColumns(_, column){
            // add current selected options to the beginning of the option list
            var current_column_index = this.flat_dest_columns.findIndex(col => col.column == column.destination_column);
            var current_unused_dest_columns = [...this.unused_dest_columns];
            if(current_column_index >=0){
                var current_column_obj = this.flat_dest_columns[current_column_index];
                current_column_obj.category = null;
                current_column_obj.text = current_column_obj.name;
                current_column_obj.value = current_column_obj.column;
                current_unused_dest_columns.unshift(current_column_obj);
            }
            return current_unused_dest_columns;
        },
        getDefaultMapping() {
            var arr = [];
            for(var i = 0; i < this.local_dest_columns.length; i++) {
                if(!this.local_dest_columns[i].optional)
                    arr.push(this.getMap(this.local_dest_columns[i]));
            }
            return arr;
        },
        getMap(col=null) {
            return {
                id: -1*Math.round(Math.random()*100000),
                client_id: this.client.id,
                data_set_id: (this.source == "dataset" ? this.data_set_id : null),
                destination_column: (col == null) ? null : col.column,
                source_column: null,  //TODO: Set some default values
                display_name: (col == null) ? null : col.name,
                data_type: (col == null) ? null : col.type,
                optional: (col == null) ? true : col.optional,
                column_logic: {
                    units: [this.getUnit()],
                    default_value: '',
                    default_type: 'static',
                    default_value_error: ''
                },
                editing: false,
                parent: (col != null && col.parent_index != null) ? this.local_dest_columns[col.parent_index].column : null
            };
        },
        getUnit() {
            return {
                id: Math.round(Math.random()*100000),
                value_type: 'static',
                value: '',
                logic: {
                    filter_logic: '1',
                    filter_option: 'custom',
                    filter_ui: 'simple',
                    logic_error_msg: null,
                    logic_units: []
                }
            };
        },
        addColumnToText(id, valueToAdd) {
            var textField = document.getElementById('unit-text-' + id );

            // Get the cursor's position
            const startPos = textField.selectionStart;
            const endPos = textField.selectionEnd;

            // Get the current value of the text field
            const currentValue = textField.value;

            // Construct the new value with the added text
            const newValue =
            currentValue.substring(0, startPos) +
            valueToAdd +
            currentValue.substring(endPos);

            // Set the new value to the text field
            textField.value = newValue;

            // Move the cursor after the added text
            const newCursorPos = startPos + valueToAdd.length;
            textField.setSelectionRange(newCursorPos, newCursorPos);

            // Trigger any necessary events, e.g., input or change
            const inputEvent = new Event('input');
            textField.dispatchEvent(inputEvent);
        },
        toggleText(column) {
            if(column.static_text == null)
                column.static_text = true;
            else column.static_text = !column.static_text;

            //if it is showing the text field
            if(column.static_text){
                column.source_column = 'CUSTOM';
                column.column_logic = {
                    units: [],
                    default_type: "static",
                    default_value: column.static_text_value
                }
            }

            //if it is showing the dropdown options
            else{
                column.column_logic = {
                    units: [this.getUnit()],
                    default_type: "static",
                    default_value: ""
                }
                column.source_column = null;
            }

            // Hide all tooltips properly
            this.hideAllTooltips();

            //Focus on the input with ID 'text' + column.id
            this.$nextTick(() => {
                if(document.getElementById('text' + column.id))
                    document.getElementById('text' + column.id).focus();
            });
            this.$forceUpdate();
        },
        updateStaticText(column) {
            column.column_logic.default_value = column.static_text_value;
        },
        editing(column) {
            //Close all of the custom editors if they are open
            this.mapping.forEach(m => {
                m.editing = false;
            });

            column.editing = true;
            this.$forceUpdate();
        },
        stopEditing(column) {
            var columnIndex = this.mapping.findIndex(m => m.id === column.id);
            const isValid = this.validateColumnLogic(columnIndex);

            // Only close editing if there are no validation errors
            if (isValid) {
                column.editing = false;
                this.$forceUpdate();
            }
        },
        selectCustomLogic(column){
            column.source_column = "CUSTOM";
        },
        selectCustomColumn(column){
            column.destination_column = "custom";
        },
        sourceColumnChange(column, column_index){
            this.errors.columns[column_index].source = '';
            if(column.column_logic == null || column.source_column == "CUSTOM" ){
                column.column_logic = {
                    units: [this.getUnit()],
                    default_value: '',
                    default_type: 'static',
                    default_value_error: ''
                }
            }
            //If the destination column has a value, validate the source column
            if(column.destination_column != null){
                this.validateColumn(column, column_index);
            }
        },
        validateColumn(column, column_index){
            this.errors.columns[column_index].source = ''; // only check null value for required fields
            // Use the validate_id endpoint to check for null values
            if(this.dataset && this.dataset.id && this.dataset.id > 0){
                window.axios.post(`/api/data_set/${this.client.url}/${this.dataset.id}/validate_id`, {
                    column_name: column.source_column,
                    destination_column: column.destination_column
                })
                .then(response => {
                    if(response.data.valid === false){
                        this.errors.columns[column_index].source = response.data.error_message;
                    }
                });
            }
        },
        selectDestinationColumn(mapping_index, column) {
            //Clear the errors
            this.errors.columns[mapping_index].avid = '';
            this.getUnusedDestinationColumns();

            //If the source column is not null, validate it
            if(column.source_column != null){
                this.validateColumn(column, mapping_index);
            }

            // Hide all tooltips
            this.hideAllTooltips();

            for(var i = 0; i < this.flat_dest_columns.length; i++) {
                if(column.destination_column == this.flat_dest_columns[i].column) {
                    column.display_name = this.flat_dest_columns[i].name;
                    column.data_type = this.flat_dest_columns[i].type;

                    if(column.data_type == 'boolean'){
                        // this.if_boolean.columns[column.id] = true;
                        // this.errors.columns[mapping_index].logic[j]  = mapping_index
                        if (column.column_logic.default_type === 'static' &&
                            !['true', 'false', true, false].includes(column.column_logic.default_value)
                        ) {
                            column.column_logic.default_value_error = "The column you selected only allows a Yes or No value.";
                        } else {
                            column.column_logic.default_value_error = '';
                        }
                        for (var j = 0; j<column.column_logic.units.length; j++){
                            if (column.column_logic.units[j].value_type == 'static' &&
                                !['true', 'false', true, false].includes(column.column_logic.units[j].value_type)
                            ){
                                this.errors.columns[mapping_index].logic[j] = "The column you selected only allows a Yes or No value.";
                            } else {
                                this.errors.columns[mapping_index].logic[j] = '';
                            }
                        }
                    }

                    //If the column is an array and this is the first time it has been selected...
                    if(this.flat_dest_columns[i].parent_index != null && column.class_names == null) {
                        this.addColumnSiblings(column, i, mapping_index);
                    }
                    //If it is an array and was already selected as part of the existing object
                    else if(this.flat_dest_columns[i].parent_index != null && column.parent != null && column.parent == this.local_dest_columns[this.flat_dest_columns[i].parent_index].column) {

                        //Find the column that is the same as the one selects
                        for(var k = mapping_index+1; k < this.mapping.length; k++){
                            if(this.mapping[k].destination_column == column.destination_column) {
                                //Find the one that isn't in the array
                                var cols = this.local_dest_columns[this.flat_dest_columns[i].parent_index].columns;
                                var arr = [];
                                //Make an array of the existing destination columns
                                for(var h = mapping_index+1; h < this.mapping.length; h++){
                                    if(this.mapping[h].optional) //Once it is optional,
                                        break;
                                    arr.push(this.mapping[h].destination_column);
                                }

                                for(var h = 0; h < cols.length; h++){
                                    //If it isn't in the list of columns, it is the one to replace the old mapping with
                                    if(!arr.includes(cols[h].column)) {
                                        //That is the column that I need to replace
                                        this.mapping[k].destination_column = cols[h].column;
                                        this.mapping[k].display_name = cols[h].name;
                                        this.mapping[k].data_type = cols[h].type;
                                        this.mapping[k].source_column = null;

                                        //Reset any errors
                                        this.errors.columns[k] = {
                                            source: "",
                                            avid: "",
                                            logic: []
                                        };
                                        break;
                                    }
                                }
                                break;
                            }
                        }

                    }
                    //If it is an array but it is a different type of object. Ex: was an address and now is an email
                    else if(this.flat_dest_columns[i].parent_index != null && column.parent != null && column.parent != this.local_dest_columns[this.flat_dest_columns[i].parent_index].column){

                        //Need to remove all of the old columns and then add the new columns
                        //First, find out how many to remove...
                        this.removeColumnSiblings(mapping_index);

                        //Now add the
                        this.addColumnSiblings(column, i, mapping_index);

                    }
                    else if(this.flat_dest_columns[i].parent_index == null && column.parent != null) {
                        //If the new column is not in an array but the previously selected one was
                        this.removeColumnSiblings(mapping_index);
                        column.parent = null;
                        column.class_names = null;
                    }

                    return;
                }
            }
        },
        removeColumnSiblings(mapping_index) {
            let num = 0;
            for(var i = mapping_index+1; i < this.mapping.length; i++){
                if(!this.mapping[i].optional) //Once it is optional,
                    num++;
                else
                    break;
            }
            //And remove them
            this.mapping.splice(mapping_index+1, num);
            this.errors.columns.splice(mapping_index+1, num);
        },
        addColumnSiblings(column, flat_dest_index, mapping_index) {
            column.parent = this.local_dest_columns[this.flat_dest_columns[flat_dest_index].parent_index].column;
            column.class_names = 'is-' + this.local_dest_columns[this.flat_dest_columns[flat_dest_index].parent_index].column;

            //Increase the mapping index since everything has to be inserted one below that spot
            mapping_index++;
            //Now add all of the other columns
            var add_middle = false;
            var cols = this.local_dest_columns[this.flat_dest_columns[flat_dest_index].parent_index].columns;
            let middle_index = this.findMiddleIndex(cols);
            //Find the index of the column variable in the cols array

            let column_index = 0;
            for(var i = 0; i < cols.length; i++)
                if(cols[i].column == column.destination_column){
                    column_index = i;
                    break;
                }


            //Loop through each column
            for(var j = 0; j < cols.length; j++) {
                //If the column is not already selected
                if(cols[j].column != column.destination_column) {
                    //Add the column to the mapping
                    this.mapping.splice(mapping_index+j, 0, this.getMap(cols[j]));
                    this.mapping[mapping_index+j].class_names = column.class_names;
                    //How

                    //If it is in the middle, add a "middle" to the class
                    if(j == middle_index - ((column_index > middle_index) ? 1 : 0) || add_middle){
                        //If add_middle is true, I need to add the class to the element prior to this one
                        this.mapping[mapping_index+j + (add_middle ? -1 : 0)].class_names += " middle";
                        add_middle = false;
                    }
                    //if it is the last one, add last to it
                    if(j == cols.length-1){
                        this.mapping[mapping_index+j].class_names += " last";
                    }

                    this.mapping[mapping_index+j].display_name = cols[j].name;
                    this.mapping[mapping_index+j].data_type = cols[j].type;
                    this.mapping[mapping_index+j].optional = false;

                    this.errors.columns.splice(mapping_index+j, 0, {
                        source: "",
                        avid: "",
                        logic: []
                    });

                }
                //If the one they selected is the middle one in the array, add it to the next one
                else if(j == middle_index) {
                    add_middle = true;
                    //Reduce mapping index to account for skipping a column
                    mapping_index--;
                }
                else if(j == cols.length-1) {
                    //Reduce mapping index to account for skipping a column
                    mapping_index--;
                    this.mapping[mapping_index+j].class_names += " last";
                }
                //Reduce mapping index to account for skipping a column
                else mapping_index--;
            }
            column.class_names += " first";
        },
        findMiddleIndex(arr) {
            //I
            const length = arr.length;
            if (length % 2 === 0) {
                return Math.floor(length / 2);
            } else {
                return Math.floor(length / 2);
            }
        },
        removeLogicUnit(event, column, i) {
            column.column_logic.units.splice(i, 1);
            event.stopPropagation();
        },
        addLogicUnit(event, column, i, columnId, sourceIndex) {
            // Prevent any event bubbling
            event.preventDefault();
            event.stopPropagation();
            
            var unit = this.getUnit();
            
            //Insert the unit in the column_logic object at the i position
            column.column_logic.units.splice(i+1, 0, unit );

            this.$nextTick(() => {
                // Close any open accordion items in this column's accordion
                const accordionContainer = document.getElementById('accordion-' + columnId);
                if (accordionContainer) {
                    const openItems = accordionContainer.querySelectorAll('.accordion-collapse.show');
                    openItems.forEach(item => {
                        item.classList.remove('show');
                        const button = accordionContainer.querySelector(`[data-bs-target="#${item.id}"]`);
                        if (button) {
                            button.classList.add('collapsed');
                            button.setAttribute('aria-expanded', 'false');
                        }
                    });
                }
                
                // Always expand the newly added accordion item
                let newIndex = (sourceIndex === 'default') ? i : i + 1;
                const newAccordionElement = document.getElementById('collapse-' + column.id + '-' + newIndex);
                if (newAccordionElement) {
                    const bsCollapse = new bootstrap.Collapse(newAccordionElement);
                    bsCollapse.show();
                }

                // Re-initialize tooltips after DOM updates
                this.initTooltips();
            });
        },
        addColumn() {
            this.mapping.push(this.getMap());
            this.errors.columns.push({
                source: "",
                avid: "",
                logic: []
            });

            // Re-initialize tooltips after adding a column
            this.$nextTick(() => {
                this.initTooltips();
            });
        },
        addAllColumns() {
            // Loop through the columns
            var keys = this.src_columns ? Object.keys(this.src_columns) : [];
            for(var i = 0; i < keys.length; i++) {
                let add_column = true;
                //Verify it hasn't already been mapped
                for(var j = 0; j < this.mapping.length; j++){
                    if(this.mapping[j].source_column == keys[i]){
                        add_column = false;
                        break;
                    }
                }

                //If it should be added, add it to mapping
                if(add_column){
                    let map = this.getMap();
                    map.source_column = keys[i];
                    map.data_type = 'string';
                    map.destination_column = 'custom';
                    map.display_name = this.src_columns[keys[i]];
                    this.mapping.push(map);
                    this.errors.columns.push({
                        source: "",
                        avid: "",
                        logic: []
                    });
                }
            }

            // Re-initialize tooltips after adding all columns
            this.$nextTick(() => {
                this.initTooltips();
            });
        },
        removeColumn(i) {
            Swal.fire({
                title: "Are you sure you want to delete this mapping?",
                text: "Proceeding with this action will delete vital connections, potentially rendering parts of the platform unusable, so proceed with caution and ensure you understand the risks.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, delete",
                customClass: {
                    popup: 'swal-warning'
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    // Destroy tooltips before removing the column
                    this.destroyTooltips();

                    //Determine if this column is part of an array
                    if(this.mapping[i].class_names != null){
                        //If the class_names contains "middle"
                        let pos = i+1;
                        //Go forward and find the first class_names that has "last"
                        for(; pos < this.mapping.length; pos++) {
                            if(this.mapping[pos].class_names.indexOf("last") >= 0) {
                                break;
                            }
                        }
                        //Work backwards to find the elements to remove
                        for(var j = pos; j >= 0; j--) {
                            let is_optional = this.mapping[j].optional;

                            this.mapping.splice(j, 1);
                            this.errors.columns.splice(j, 1);

                            //The optional flag will be true only for the first one
                            if(is_optional)
                                break;
                        }
                    }
                    else {
                        //Remove the column
                        this.mapping.splice(i, 1);
                        this.errors.columns.splice(i, 1);
                    }

                    // Refresh unused destination list so the removed column's destination is back in the dropdown
                    this.getUnusedDestinationColumns();

                    // Re-initialize tooltips after DOM update
                    this.$nextTick(() => {
                        this.initTooltips();
                    });
                }
            });
        },
        previewSourceColumn(column, mapping_index) {
            // Reset all preview table states
            this.preview_table_val = [];
            this.preview_table_logic = [];
            this.preview_table = [];
            this.preview_table_data_type = [];
            this.preview_detail_table = [];
            this.preview_detail_index = 0;
            this.depth = 1;
            this.drill_index = null;

            this.validateColumnLogic(mapping_index);

            //Show the column value of the recently selected table (except CUSTOM)
            if(column.source_column != "CUSTOM") {
                this.preview_table_val[0] = column.source_column;
                this.preview_table_data_type[0] = column.data_type; // Store the data_type
                //Calling this will show the loading message
                this.$forceUpdate();
                this.updatePreviewTable({value: column.source_column});
            }
            else {
                this.preview_table_val[0] = '*** Custom Logic ***';
                this.preview_table_logic[0] = column.column_logic;
                this.preview_table_data_type[0] = column.data_type; // Store the data_type
                this.$forceUpdate();
                this.getPreviewTableData(column.source_column, column.column_logic, mapping_index);
            }

        },
        requestAISuggestion(column, index) {
            // Disable the button for this column
            this.ednaButtonDisabled[index] = true;
            
            // If no existing mapping, submit directly
            if (!column.source_column || column.source_column === '' || column.source_column === null) {
                this.submitAISuggestion(column, index, null);
            } else {
                // Has existing mapping - show modal for refinement context
                this.openAISuggestionModal(column, index);
            }
        },
        submitAISuggestion(column, index, userContext) {
            // Check if we're working with a file or a data set
            if (this.source === 'file') {
                // Validate that source_type is set (required for file endpoint)
                if (!this.dataset || !this.dataset.source_type) {
                    this.showNotification({
                        text: 'Please select a data category first before requesting AI suggestions.',
                        type: 'error'
                    });
                    this.ednaButtonDisabled[index] = false;
                    return;
                }

                // Use file-mapping endpoint for files
                const data = {
                    file_id: parseInt(this.data_source_id),
                    destination_column: column.destination_column,
                    source_type: this.dataset.source_type,
                };

                // Send source_subtype if available
                if (this.dataset.source_subtype) {
                    data.source_subtype = this.dataset.source_subtype;
                }

                if (userContext) {
                    data.user_context = userContext;
                }

                window.axios.post(`/api/file-mapping/${this.client.url}/suggest-column`, data)
                    .then(response => {
                        // File endpoint doesn't return column_mapping, suggestions are stored in file metadata
                        this.showNotification({
                            icon: '/img/icons/nav-icons/Edna.svg',
                            text: 'Your column mapping suggestion is being generated. You\'ll be notified when it\'s ready!',
                            type: 'info'
                        });
                        
                        // Start polling as fallback for missed Echo events
                        const requestKey = `column-file-${this.data_source_id}-${column.destination_column}`;
                        this.startPolling({
                            requestKey,
                            checkFn: createFileCheckFunction({
                                clientUrl: this.client.url,
                                fileId: parseInt(this.data_source_id),
                                type: 'column',
                                destinationColumn: column.destination_column
                            }),
                            onSuccess: (data) => {
                                this.ednaButtonDisabled[index] = false;
                                if (data && data.proposal) {
                                    // Show notification that polling detected the update
                                    this.showNotification({
                                        icon: '/img/icons/nav-icons/Edna.svg',
                                        text: `AI has suggested a mapping for ${column.display_name || column.destination_column}. Click to review.`,
                                        type: 'success',
                                        action: {
                                            type: 'openFileMappingProposal',
                                            file_id: parseInt(this.data_source_id),
                                            destination_column: column.destination_column,
                                            proposal: data.proposal,
                                            reasoning: data.reasoning,
                                            previous_response_id: data.response_id
                                        }
                                    });
                                }
                            },
                            onTimeout: () => {
                                this.ednaButtonDisabled[index] = false;
                            },
                            onNoResult: () => {
                                this.ednaButtonDisabled[index] = false;
                                this.showNotification({
                                    icon: '/img/icons/avid-icons/danger.svg',
                                    text: 'The AI suggestion completed but no changes were detected. Please try again.',
                                    type: 'error'
                                });
                            }
                        });
                    })
                    .catch(error => {
                        console.error('Error requesting AI suggestion:', error);
                        this.showNotification({
                            text: 'Failed to request AI suggestion. Please try again.',
                            type: 'error'
                        });
                        
                        // Re-enable the button on error as well
                        this.ednaButtonDisabled[index] = false;
                    });
            } else {
                // Use column-mapping endpoint for data sets
                const data = {
                    data_set_id: this.data_source_id,
                    destination_column: column.destination_column,
                    order: index + 1, // Send order (1-indexed)
                };

                // Only send column_mapping_id if it's a real ID (positive number)
                // Negative IDs are temporary and mean the column hasn't been saved yet
                if (column.id && column.id > 0) {
                    data.column_mapping_id = column.id;
                }

                // Send source_subtype so backend can look up column metadata
                if (this.dataset && this.dataset.source_subtype) {
                    data.source_subtype = this.dataset.source_subtype;
                }

                if (userContext) {
                    data.user_context = userContext;
                }

                window.axios.post(`/api/column-mapping/${this.client.url}/suggest`, data)
                    .then(response => {
                        const suggestionId = response.data.column_mapping_suggestion_id;
                        const columnMappingData = response.data.column_mapping;

                        if (columnMappingData && column.id < 0) {
                            const columnIndex = this.mapping.findIndex(c => c.id === column.id);
                            if (columnIndex !== -1) {
                                this.mapping[columnIndex].id = columnMappingData.id;
                                this.temporaryColumnMappingIds.push(columnMappingData.id);
                            }
                        } else if (columnMappingData && column.id > 0) {
                            const columnIndex = this.mapping.findIndex(c => c.id === column.id);
                            if (columnIndex !== -1 && !column.source_column && !column.column_logic) {
                                if (!this.temporaryColumnMappingIds.includes(columnMappingData.id)) {
                                    this.temporaryColumnMappingIds.push(columnMappingData.id);
                                }
                            }
                        } else if (suggestionId && column.id < 0) {
                            const columnIndex = this.mapping.findIndex(c => c.id === column.id);
                            if (columnIndex !== -1) {
                                this.mapping[columnIndex].column_mapping_suggestion_id = suggestionId;
                                this.temporarySuggestionIds.push(suggestionId);
                            }
                        }

                        this.showNotification({
                            icon: '/img/icons/nav-icons/Edna.svg',
                            text: 'Your column mapping suggestion is being generated. You\'ll be notified when it\'s ready!',
                            type: 'info'
                        });

                        const columnMappingId = columnMappingData?.id || column.id;
                        if (columnMappingId && columnMappingId > 0) {
                            const requestKey = `column-dataset-${this.data_source_id}-${column.destination_column}`;
                            this.startPolling({
                                requestKey,
                                checkFn: createDataSetColumnCheckFunction({
                                    clientUrl: this.client.url,
                                    columnMappingId: columnMappingId
                                }),
                                onSuccess: () => {
                                    this.ednaButtonDisabled[index] = false;
                                    // Modal opens only when the user clicks the notification (backend sends it).
                                },
                                onTimeout: () => { this.ednaButtonDisabled[index] = false; },
                                onNoResult: () => {
                                    this.ednaButtonDisabled[index] = false;
                                    this.showNotification({
                                        icon: '/img/icons/avid-icons/danger.svg',
                                        text: 'The AI suggestion completed but no changes were detected. Please try again.',
                                        type: 'error'
                                    });
                                }
                            });
                        } else if (suggestionId) {
                            const requestKey = `column-suggestion-${this.data_source_id}-${suggestionId}`;
                            this.startPolling({
                                requestKey,
                                checkFn: createColumnMappingSuggestionCheckFunction({
                                    clientUrl: this.client.url,
                                    suggestionId
                                }),
                                onSuccess: () => {
                                    this.ednaButtonDisabled[index] = false;
                                    // Modal opens only when the user clicks the notification (backend sends it).
                                },
                                onTimeout: () => { this.ednaButtonDisabled[index] = false; },
                                onNoResult: () => {
                                    this.ednaButtonDisabled[index] = false;
                                    this.showNotification({
                                        icon: '/img/icons/avid-icons/danger.svg',
                                        text: 'The AI suggestion completed but no changes were detected. Please try again.',
                                        type: 'error'
                                    });
                                }
                            });
                        }
                    })
                    .catch(error => {
                        console.error('Error requesting AI suggestion:', error);
                        this.showNotification({
                            text: 'Failed to request AI suggestion. Please try again.',
                            type: 'error'
                        });
                        
                        // Re-enable the button on error as well
                        this.ednaButtonDisabled[index] = false;
                    });
            }
        },
        openAISuggestionModal(column, index) {
            // For now, we'll use a simple prompt. Later this can be replaced with a proper modal component
            Swal.fire({
                title: 'Refine Column Mapping',
                html: `
                    <p class="mb-2">Current mapping: <strong>${this.formatSourceColumn(column.source_column)}</strong></p>
                    <p class="mb-2">How can we improve the current mapping?</p>
                    <textarea id="ai-context" class="form-control" placeholder="E.g., Map to column X instead; handle blanks differently, etc." style="width: 100%; min-height: 100px;"></textarea>
                `,
                showCancelButton: true,
                confirmButtonText: 'Submit',
                cancelButtonText: 'Cancel',
                preConfirm: () => {
                    const context = document.getElementById('ai-context').value;
                    return context || null;
                }
            }).then((result) => {
                if (result.isConfirmed && result.value) {
                    this.submitAISuggestion(column, index, result.value);
                } else {
                    // Re-enable the button if user cancels
                    this.ednaButtonDisabled[index] = false;
                }
            });
        },
        updatePreviewTable(column_obj) {
            this.preview_table[this.depth-1] = null;
            this.preview_table_logic[this.depth-1] = null;

            if(column_obj == null || column_obj.value == "") {
                this.preview_table_val[this.depth-1] = null
                this.preview_table_logic[this.depth-1] = null;
                return;
            }

            // Store the data_type for the current depth level
            // For the second level, we need to determine the data_type from the source columns
            if(this.depth == 2) {
                // Find the data_type from the source columns
                let data_type = 'string'; // default
                if(this.src_columns && this.src_columns[column_obj.value]) {
                    // Try to find the data_type from the mapping if it exists
                    for(let i = 0; i < this.mapping.length; i++) {
                        if(this.mapping[i].source_column === column_obj.value) {
                            data_type = this.mapping[i].data_type || 'string';
                            break;
                        }
                    }
                }
                this.preview_table_data_type[this.depth-1] = data_type;
            }

            this.getPreviewTableData(column_obj.value);
        },
        getPreviewTableData(column, column_logic = null, mapping_index = null) {
            // Hide all tooltips properly
            this.hideAllTooltips();
            
            let data_type = null;
            if(mapping_index != null) {
                data_type = this.mapping[mapping_index].data_type;
            } else {
                // Use the stored data_type for the current depth level
                data_type = this.preview_table_data_type[0];
            }

            var data = {
                client: this.client,
                source: this.source,
                column: column,
                logic: column_logic,
                limit: 10,
                data_source_id: this.data_source_id,
                value: this.dataset.filter,
                data_type: data_type
            };

            //I need to add the filter for the first level if I'm two down.
            if(this.depth == 2) {
                if(this.preview_table_val[0] == '*** Custom Logic ***') {
                    data.filter = [{
                        column: this.preview_table_val[0],
                        logic: this.preview_table_logic[0],
                        value: this.preview_table[0][this.drill_index].name
                    }];
                }
                else {
                    data.filter = [{
                        column: this.preview_table_val[0],
                        value: this.preview_table[0][this.drill_index].name
                    }];
                }
                // Store the data_type for the second level
                this.preview_table_data_type[1] = data_type;
            }

            var _self = this;

            window.axios.post('/api/bigquery/get_samples', data)
                .then(response => {
                _self.preview_table[_self.depth-1] = response.data.samples;
                _self.$forceUpdate();
            })
            .catch(error => {
                // Handle errors here
                if (error.response && error.response.status == 400 && error.response.data && error.response.data.error_type == 'missing_column') {
                    //Find the object that has a value of the column variable and remove it from the src_column_array array.
                    var index = _self.src_column_array.findIndex(c => c.value == column);
                    _self.src_column_array.splice(index, 1);
                    _self.preview_column_array.splice(index, 1);

                    _self.preview_table_val = [];

                    //Find all of the places where the source column is set to the column
                    for(var i = 0; i < _self.mapping.length; i++) {
                        if(_self.mapping[i].source_column == column)
                            _self.mapping[i].source_column = null;
                    }

                    this.showNotification({
                        text: "The selected column has been removed. The database column was removed from the source data. We've updated this data set to reflect that recent change.",
                        type: 'error'
                    })

                    _self.$forceUpdate();
                }
                else if (error.response && error.response.status == 400 && error.response.data && error.response.data.error_type == 'sql_error') {
                    this.showNotification({
                        text: `There is an error with your custom logic: ${error.response.data.message}`,
                        type: 'error'
                    })
                }
                else if (error.response && error.response.status == 400 && error.response.data && error.response.data.error) {
                    // Handle general 400 errors with error message
                    this.showNotification({
                        text: error.response.data.error || "An error occurred while processing your request.",
                        type: 'error'
                    });
                }
                else if (error.response && error.response.status == 500 && error.response.data && error.response.data.error) {
                    // Handle 500 errors (BigQuery execution errors)
                    this.showNotification({
                        text: "A database error occurred. Please try again or contact support if the problem persists.",
                        type: 'error'
                    });
                }
                else if (error.response && error.response.status == 403 && error.response.data && error.response.data.error) {
                    // Handle 403 errors (access denied)
                    this.showNotification({
                        text: error.response.data.error || "You don't have permission to access this data.",
                        type: 'error'
                    });
                }
                else {
                    // Handle other types of errors (network errors, timeouts, etc.)
                    console.error('Error in getPreviewTableData:', error);
                    let errorMessage = "Unable to fetch preview data. Please try again.";
                    
                    if (error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message;
                    } else if (error.message) {
                        errorMessage = error.message;
                    }
                    
                    this.showNotification({
                        text: errorMessage,
                        type: 'error'
                    });
                }
            });
        },
        previewRecords(column_value) {

            var _self = this;
            var data = {
                data_source: this.source,
                filter:  [{
                    column: typeof this.preview_table_val[this.depth-1] == 'object' ? this.preview_table_val[this.depth-1].value : this.preview_table_val[this.depth-1],
                    logic: this.preview_table_logic[this.depth-1],
                    value:  column_value
                }],
                limit: 10,
                data_source_id: this.data_source_id,
                client_id: this.client.id,
                value: this.dataset.filter,
                data_type: this.preview_table_data_type[this.depth-1] // Add the data_type parameter
            };

            //I need to add the filter for the first level if I'm two down.
            if(this.depth == 2) {
                data.filter.push({
                    column: this.preview_table_val[0],
                    logic: this.preview_table_logic[0],
                    value: this.preview_table[0][this.drill_index].name
                });
            }

            this.preview_detail_loading = column_value;

            window.axios.post('/api/bigquery/get_detailed_samples', data).then(response => {
                if(response.status == 200) {

                    _self.preview_detail_table = response.data.samples;
                    _self.preview_detail_loading = "";

                    var myModal = new bootstrap.Modal(document.getElementById('column-mapping-preview-'+this.data_source_id))
                    myModal.show()
                }
                });
        },
        drilldown(index, _) {
            this.depth++;
            this.drill_index = index;
        },
        removeDrilldown() {
            this.drill_index = null;
            this.depth--;
            this.preview_table_val[1] = null;
            this.preview_table[1] = null;
            this.preview_table_data_type[1] = null; // Clear the data_type for the second level

        },
        setDataType(index, type) {
            if(this.errors.columns[index].avid.indexOf('name') > -1)
                this.errors.columns[index].avid = 'Please enter a unique name for the column in the field above';
            else
                this.errors.columns[index].avid = '';

            this.mapping[index].data_type = type;

            const dropdownToggle = document.getElementById('dropdown-'+index);
            if (dropdownToggle) {
                dropdownToggle.click();
            }
        },
        columnExists(index, col_name) {
            //Now loop through the mapping to ensure this column doesn't already exist
            for(var i = 0; i < this.mapping.length; i++) {
                if(index != i && this.mapping[i].display_name == col_name) {
                    this.errors.columns[index].avid = 'A column with that name already exists.';
                    return true;
                }
            }
            //Remove old errors
            this.errors.columns[index].avid = '';
            return false;
        },
        sanitizeSQLStatement(i, j, unit) {
            //Only do this for SQL stuff
            if(unit.value_type != 'sql'){
                //Clear the errors
                if(unit.value.trim() != "" && this.errors.columns[i].logic[j] != null){
                    this.errors.columns[i].logic[j] = "";
                    this.$forceUpdate();
                }
                return;
            }

            // List of keywords to remove from the parameterValue
            const blacklistedKeywords = ['UPDATE', 'DROP', 'DELETE', 'INSERT', 'TRUNCATE'];

            // Remove blacklisted keywords
            let sanitizedValue = unit.value;
            blacklistedKeywords.forEach(keyword => {
                const regex = new RegExp(`\\b${keyword}\\b`, 'gi');
                sanitizedValue = sanitizedValue.replace(regex, '');
            });

            // Remove semicolons
            sanitizedValue = sanitizedValue.replace(/;/g, '');

            unit.value= sanitizedValue;
            //Clear the errors
            if(unit.value.trim() != "" && this.errors.columns[i].logic[j] != null){
                this.errors.columns[i].logic[j] = "";
                this.$forceUpdate();
            }
        },
        hasAnyLogicUnitError(column) {
            if(column.source_column != 'CUSTOM' || !column.column_logic)
                return false;

            let units = column.column_logic.units;

            //Look at the logic units
            for(var j = 0; j < units.length; j++){
                if(units[j].logic != null && this.hasLogicUnitError(units[j].logic) )
                    return true;
                //If the value is blank
                if(units[j].value == null || ( typeof units[j].value === 'string'  &&  units[j].value.trim() == ""))
                    return true;

                //If the value is of type column and the column isn't mapped
                else if (units[j].value_type == 'column' && this.src_columns[this.getColumnValue(units[j].value)] == null)
                    return true;
            }
            return false;
        },
        hasLogicUnitError(units) {
            for(var i = 0; i < units.logic_units.length; i++) {
                //If one of the fields hasn't been selected ...

                //If the logic operator is an object
                var operator = units.logic_units[i].operator;
                if(typeof operator == "object" && operator != null)
                    operator = units.logic_units[i].operator.value;

                if(units.logic_units[i].db_column == null ||
                    units.logic_units[i].db_column.value == "" || operator == null || operator == "" ||
                    ( units.logic_units[i].value == "" && operator.indexOf("NULL") == -1))
                    return true;

                //If the database column is no longer available in the source table
                if(this.src_columns[units.logic_units[i].db_column.value] == null) {
                    return true;
                }

            }
            return false;
        },
        isValid() {

            var is_valid = true;
            //Loop through each of the different fields
            for(var i = 0; i < this.mapping.length; i++) {
                //For the source, check whether a column has been selected
                // (Or, if it has a parent, it may be optional)
                if((this.mapping[i].source_column == null || this.mapping[i].source_column.trim() == "") && (this.mapping[i].optional || this.mapping[i].parent == null)){
                    is_valid = false;
                    this.errors.columns[i].source = 'This field is required. Please select an option above.';
                }
                //If the column is CUSTOM, validate the custom values
                else if(this.mapping[i].source_column == 'CUSTOM') {

                    let units = this.mapping[i].column_logic.units;
                    var unit_is_valid = this.isUnitValid(i, units);
                    if(!unit_is_valid) is_valid = false;

                }

                //This will be set if they have a duplicate column name set
                if(this.errors.columns[i].avid != '')
                    is_valid = false;

                //For the avid column, is a data type selected and does it have a value
                if(this.mapping[i].destination_column == null || this.mapping[i].destination_column == ''){
                    is_valid = false;
                    this.errors.columns[i].avid = 'This field is required. Please select an option above.';
                }
                //If the name is blank and data type is empty
                else if (this.mapping[i].destination_column.indexOf('custom') > -1 && (this.mapping[i].display_name == null || this.mapping[i].display_name == '') && this.mapping[i].data_type == null ) {

                    is_valid = false;
                    this.errors.columns[i].avid = 'Custom columns require you to enter a unique name and to select a data type from the dropdown above.';
                }

                else if (this.mapping[i].destination_column.indexOf('custom') > -1 && (this.mapping[i].display_name == null || this.mapping[i].display_name == '')) {

                    is_valid = false;
                    this.errors.columns[i].avid = 'Please enter a unique name for the column in the field above';
                }
                //If just the data type is empty
                else if (this.mapping[i].destination_column.indexOf('custom') > -1 &&  this.mapping[i].data_type == null ) {

                    is_valid = false;
                    this.errors.columns[i].avid = 'Please select the data type of this column from the dropdown above.';
                }

            }
            return is_valid;

        },
        isUnitValid(i, units) {
            this.errors.columns[i].logic = new Array(units.length);
            var is_valid = true;
            let dest_data_type = this.mapping[i].data_type; //boolean

            for(var j = 0; j < units.length; j++){
                //Check for empty output values
                if(units[j].value == null || ( typeof units[j].value === 'string'  &&  units[j].value.trim() == "")) {
                    is_valid = false;
                    this.errors.columns[i].source = 'There is an error with the custom logic defined below.'
                    this.errors.columns[i].logic[j] = 'The output value field is required.'
                }
                //If the source columns no longer contain the mapped field
                else if(units[j].value_type == 'column' && this.src_columns[this.getColumnValue(units[j].value)] == null) {

                    is_valid = false;
                    this.errors.columns[i].source = 'A column used in the logic below has been removed from the latest data refresh.'
                    this.errors.columns[i].logic[j] = 'The output value field that was mapped has been removed in the most recent data refresh. Please select a new value.'
                }else if(units[j].value_type == 'static' && !this.isValidForDataType(dest_data_type, units[j].value )) {
                    is_valid = false;
                    this.errors.columns[i].source = 'The output of one of the logic blocks below does not match the data type of the Avid column.'
                    this.errors.columns[i].logic[j] = 'The Avid column is a ' + dest_data_type + ' column. Your "Output Value" should match this data type.';
                }

                //  Also validate the logic statement
                if(this.hasLogicUnitError(units[j].logic) ){
                    is_valid = false;
                    this.errors.columns[i].source = 'There is an error with the custom logic defined below.';

                    let row = i;
                    let col = j;

                    this.$nextTick(() => {
                        //Show the accordion units with an error
                        document.getElementById('collapse-' + this.mapping[row].id+'-' + col).classList.add("show");
                        document.querySelector('#heading-' + this.mapping[row].id+'-' + col + ' .accordion-button').classList.remove('collapsed');

                        const refKey = 'simple-' + this.mapping[row].id + '-' + col;
                        const refComponent = this.$refs[refKey];
                        if (refComponent && refComponent[0] && typeof refComponent[0].isFormValid === 'function') {
                            refComponent[0].isFormValid();
                        }
                    });
                }
            }
            
            // Clear source error if all logic units are valid
            if (is_valid) {
                this.errors.columns[i].source = '';
            }
            
            return is_valid;
        },
        isValidForDataType(type, value){
            if (type === 'boolean') {
                // Check if value is 'true' or 'false'
                if(typeof value === 'string') {
                    return value.toLowerCase() === 'true' || value.toLowerCase() === 'false';
                } else { // when value is true of false as Boolean
                    //Return true if the value is a boolean
                    return typeof value === 'boolean';
                }
            }
            value = value.trim();
            if (type === 'date') {
                // Define regex patterns for different date formats
                const datePatterns = [
                    /^\d{4}-\d{2}-\d{2}$/, // YYYY-MM-DD
                    /^\d{8}$/, // YYYYMMDD
                    /^\d{1,2}\/\d{1,2}\/\d{4}$/, // MM/DD/YYYY
                    /^\d{1,2}\/\d{1,2}\/\d{2}$/, // MM/DD/YY
                    /^\d{6}$/, // MMDDYY
                    /^\d{5}$/, // MDDYY
                    /^\d{1,2}[\s,/\-_]+(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)[\s,/\-_]+\d{2}$/i, // DD-MMM-YY
                    /^\d{1,2}[\s,/\-_]+(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)[\s,/\-_]+\d{4}$/i, // DD-MMM-YYYY
                    /^(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)[\s,/\-_]+\d{1,2}[\s,/\-_]+\d{2}$/i, // MMM-DD-YY
                    /^(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)[\s,/\-_]+\d{1,2}[\s,/\-_]+\d{4}$/i, // MMM-DD-YYYY
                    /^\d{1,2}(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)\d{4}$/i // DDMMMYYYY
                ];

                // Check if value matches any of the patterns
                for (let pattern of datePatterns) {
                    if (pattern.test(value)) {
                        return true;
                    }
                }
                return false;
            }
            if (type === 'timestamp') {
                // Define regex patterns for different timestamp formats
                const timestampPatterns = [
                    /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/, // YYYY-MM-DD HH:MM:SS
                    /^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}$/, // DD/MM/YYYY HH:MM
                    /^\d{2}\/\d{2}\/\d{4}$/, // MM/DD/YYYY
                    /^[A-Z][a-z]+\s\d{2},\s\d{4}\s\d{2}:\d{2}:\d{2}$/, // Month DD, YYYY HH:MM:SS
                    /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/ // YYYY-MM-DDTHH:MM:SSZ
                ];

                // Check if value matches any of the patterns
                for (let pattern of timestampPatterns) {
                    if (pattern.test(value)) {
                        return true;
                    }
                }
                return false;
            }
            if (type === 'integer') {
                // Check if value is an integer
                const intPattern = /^-?\d+$/;
                return intPattern.test(value);
            }
            if (type === 'numeric') {
                // Check if value is a valid number
                return !isNaN(value) && !isNaN(parseFloat(value));
            }

            return true;
        },
        toggleExpand() {
            this.is_expanded = !this.is_expanded;

            // Re-initialize tooltips after DOM updates
            this.$nextTick(() => {
                this.initTooltips();
            });
        },

        // Method to initialize tooltips
        initTooltips() {
            // First hide any existing tooltips
            this.hideAllTooltips();

            // Clear existing tooltip list
            if (this.tooltipList) {
                this.tooltipList.forEach(tooltip => {
                    try {
                        if (tooltip && typeof tooltip.dispose === 'function') {
                            tooltip.dispose();
                        }
                    } catch (error) {
                        // Ignore disposal errors
                    }
                });
            }
            this.tooltipList = [];

            // Initialize new tooltips with proper event handling
            const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
            this.tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => {
                try {
                    if (!tooltipTriggerEl || !tooltipTriggerEl.parentNode) {
                        return null;
                    }
                    
                    const tooltip = new window.bootstrap.Tooltip(tooltipTriggerEl, {
                        trigger: 'hover',
                        boundary: 'window',
                        delay: { show: 100, hide: 100 } // Add small delay to prevent flickering
                    });

                    // Add event listeners to prevent multiple tooltips
                    const showTooltip = () => {
                        // Hide all other tooltips before showing this one
                        this.forceHideAllTooltips();
                        // Small delay to ensure proper hiding
                        setTimeout(() => {
                            try {
                                tooltip.show();
                            } catch (error) {
                                // Ignore show errors
                            }
                        }, 100);
                    };

                    const hideTooltip = () => {
                        try {
                            tooltip.hide();
                        } catch (error) {
                            // Ignore hide errors
                        }
                    };

                    // Remove existing listeners to prevent duplicates
                    tooltipTriggerEl.removeEventListener('mouseenter', showTooltip);
                    tooltipTriggerEl.removeEventListener('mouseleave', hideTooltip);
                    tooltipTriggerEl.removeEventListener('click', hideTooltip);

                    // Add new listeners
                    tooltipTriggerEl.addEventListener('mouseenter', showTooltip);
                    tooltipTriggerEl.addEventListener('mouseleave', hideTooltip);
                    tooltipTriggerEl.addEventListener('click', hideTooltip);

                    return tooltip;
                } catch (error) {
                    console.warn('Error initializing tooltip:', error);
                    return null;
                }
            }).filter(Boolean);
        },

        // Method to destroy all tooltips
        destroyTooltips() {
            if (!this.tooltipList) {
                return;
            }

            this.tooltipList.forEach(tooltip => {
                try {
                    if (tooltip && typeof tooltip.dispose === 'function') {
                        tooltip.dispose();
                    }
                } catch (error) {
                    // Ignore disposal errors
                }
            });
            this.tooltipList = [];

            // Remove any lingering tooltip elements from the DOM
            try {
                const tooltipElements = document.querySelectorAll('.tooltip');
                tooltipElements.forEach(element => {
                    if (element && element.parentNode) {
                        element.parentNode.removeChild(element);
                    }
                });
            } catch (error) {
                // Ignore removal errors
            }
        },

        // Method to hide all tooltips without destroying them
        hideAllTooltips() {
            if (!this.tooltipList) {
                return;
            }

            this.tooltipList.forEach(tooltip => {
                try {
                    if (tooltip && typeof tooltip.hide === 'function') {
                        tooltip.hide();
                    }
                } catch (error) {
                    // Ignore hide errors
                }
            });

            // Hide any lingering tooltip elements
            try {
                const tooltipElements = document.querySelectorAll('.tooltip');
                tooltipElements.forEach(element => {
                    if (element) {
                        element.classList.remove('show');
                        element.style.display = 'none';
                    }
                });
            } catch (error) {
                // Ignore hide errors
            }
        },
        getColumnValue(unitValue) {
            // Handle both string and object values for column type
            if (typeof unitValue === 'object' && unitValue !== null) {
                return unitValue.value;
            }
            return unitValue;
        },
        getFilteredPreviewRows(tableIndex) {
            if (!this.preview_table[tableIndex] || this.preview_table[tableIndex] == null) {
                return [];
            }
            
            return this.preview_table[tableIndex].filter((_, rowIndex) => {
                return this.drill_index == null || this.drill_index == rowIndex || (tableIndex + 1) > 1;
            });
        },
        validateAndClearColumnErrors(columnIndex) {
            // Validate the column and clear errors if valid
            if (this.mapping[columnIndex] && this.mapping[columnIndex].source_column === 'CUSTOM') {
                const units = this.mapping[columnIndex].column_logic.units;
                const isValid = this.isUnitValid(columnIndex, units);
                
                // If valid, clear the source error
                if (isValid) {
                    this.errors.columns[columnIndex].source = '';
                }
                
                return isValid;
            }
            return true;
        },
        // Method to be called from child components (like query-builder-simplified) to validate and clear errors
        validateColumnLogic(columnIndex) {
            return this.validateAndClearColumnErrors(columnIndex);
        },

        // Global tooltip management handler
        handleGlobalTooltipManagement(e) {
            if (e.target.hasAttribute('data-bs-toggle') && e.target.getAttribute('data-bs-toggle') === 'tooltip') {
                // Hide all other tooltips when hovering over a new tooltip trigger
                this.forceHideAllTooltips();
            }
        },

        // Force hide all tooltips - more aggressive approach
        forceHideAllTooltips() {
            // Hide all tooltips in the tooltip list
            if (this.tooltipList) {
                this.tooltipList.forEach(tooltip => {
                    try {
                        if (tooltip && typeof tooltip.hide === 'function') {
                            tooltip.hide();
                        }
                    } catch (error) {
                        // Ignore hide errors
                    }
                });
            }

            // Force hide all tooltip elements in the DOM
            try {
                const tooltipElements = document.querySelectorAll('.tooltip');
                tooltipElements.forEach(element => {
                    if (element) {
                        element.classList.remove('show');
                        element.style.display = 'none';
                        element.style.opacity = '0';
                        element.style.visibility = 'hidden';
                        element.style.pointerEvents = 'none';
                    }
                });
            } catch (error) {
                // Ignore removal errors
            }
        },
        handleOpenProposalModal(event) {
            const actionData = event.detail;
            
            if (actionData && actionData.type === 'openColumnMappingProposal') {
                if (actionData.destination_column && this.stopPolling) {
                    const datasetKey = `column-dataset-${this.data_source_id}-${actionData.destination_column}`;
                    this.stopPolling(datasetKey);
                    if (actionData.column_mapping_suggestion_id) {
                        this.stopPolling(`column-suggestion-${this.data_source_id}-${actionData.column_mapping_suggestion_id}`);
                    }
                }

                if (this.isProcessingProposal &&
                    this.proposalModalData &&
                    this.proposalModalData.column_mapping_id === actionData.column_mapping_id &&
                    this.proposalModalData.column_mapping_suggestion_id === actionData.column_mapping_suggestion_id) {
                    return;
                }

                if (actionData.data_set_id && this.data_source_id && actionData.data_set_id !== this.data_source_id) {
                    return;
                }

                this.isProcessingProposal = true;

                if (actionData.column_mapping_id) {
                    const columnIndex = this.mapping.findIndex(c => c.id === actionData.column_mapping_id);
                    if (columnIndex !== -1) {
                        this.ednaButtonDisabled[columnIndex] = false;
                    }
                } else if (actionData.destination_column) {
                    const columnIndex = this.mapping.findIndex(c => c.destination_column === actionData.destination_column);
                    if (columnIndex !== -1) {
                        this.ednaButtonDisabled[columnIndex] = false;
                    }
                }

                this.proposalModalData = {
                    data_set_id: actionData.data_set_id,
                    column_mapping_id: actionData.column_mapping_id || null,
                    column_mapping_suggestion_id: actionData.column_mapping_suggestion_id || null,
                    destination_column: actionData.destination_column,
                    previous_response_id: actionData.previous_response_id || null,
                    proposal: actionData.proposal || null,
                    reasoning: actionData.reasoning || null
                };
                // Force re-render by updating key - this will cause the modal to mount
                this.proposalModalKey += 1;
                
                // Wait for modal to be rendered and mounted, then show it
                this.$nextTick(() => {
                    // Try multiple times with increasing delays to ensure modal is ready
                    const tryShowModal = (attempt = 1) => {
                        if (this.$refs.proposalModal) {
                            if (typeof this.$refs.proposalModal.show === 'function') {
                                this.$refs.proposalModal.show();
                                // Clear processing flag after modal is shown
                                this.isProcessingProposal = false;
                            } else {
                                // Modal might not be fully ready yet, try again
                                if (attempt < 5) {
                                    setTimeout(() => tryShowModal(attempt + 1), 100);
                                } else {
                                    console.error('ColumnMapping: Could not show modal after multiple attempts');
                                    this.isProcessingProposal = false;
                                }
                            }
                        } else {
                            // Modal ref not available yet, try again
                            if (attempt < 5) {
                                setTimeout(() => tryShowModal(attempt + 1), 100);
                            } else {
                                console.error('ColumnMapping: Modal ref not available after multiple attempts');
                                this.isProcessingProposal = false;
                            }
                        }
                    };
                    tryShowModal();
                });
            }
        },
        handleReEnableSuggestion(event) {
            const actionData = event.detail;
            if (!actionData) {
                return;
            }
            
            // Check if this is for our component
            let isForThisComponent = false;
            
            if ((this.source === 'dataset' || this.source === 'data_set') && actionData.data_set_id) {
                // Compare as numbers to handle string/number mismatch
                const actionDataSetId = parseInt(actionData.data_set_id);
                const componentDataSetId = parseInt(this.data_source_id);
                isForThisComponent = actionDataSetId === componentDataSetId;
            } else if (this.source === 'file' && actionData.file_id) {
                const actionFileId = parseInt(actionData.file_id);
                const componentFileId = parseInt(this.data_source_id);
                isForThisComponent = actionFileId === componentFileId;
            }
            
            if (!isForThisComponent) {
                return;
            }
            
            // For column mappings, we need destination_column or column_mapping_id
            if (actionData.destination_column || actionData.column_mapping_id) {
                // Ensure mapping array is available
                if (!this.mapping || this.mapping.length === 0) {
                    // If mapping isn't ready yet, try again after a short delay
                    setTimeout(() => {
                        this.handleReEnableSuggestion(event);
                    }, 500);
                    return;
                }
                
                // Find the column index by column_mapping_id or destination_column
                let columnIndex = -1;
                
                if (actionData.column_mapping_id) {
                    columnIndex = this.mapping.findIndex(
                        c => c.id && parseInt(c.id) === parseInt(actionData.column_mapping_id)
                    );
                }
                
                // If not found by ID, try destination_column
                if (columnIndex === -1 && actionData.destination_column) {
                    columnIndex = this.mapping.findIndex(
                        c => c.destination_column === actionData.destination_column
                    );
                }
                
                if (columnIndex !== -1) {
                    // Direct assignment should work with Vue 3 reactivity
                    this.ednaButtonDisabled[columnIndex] = false;
                } else {
                    // Debug: log if column not found
                    console.warn('ColumnMapping: Could not find column to re-enable', {
                        actionData,
                        source: this.source,
                        data_source_id: this.data_source_id,
                        mappingLength: this.mapping.length,
                        mappingDestinations: this.mapping.map(c => c.destination_column),
                        mappingIds: this.mapping.map(c => c.id),
                    });
                }
            }
        },
        handleOpenFileProposalModal(event) {
            const actionData = event.detail;
            
            if (actionData && actionData.type === 'openFileMappingProposal') {
                // Stop polling since we received the event
                if (actionData.destination_column && this.stopPolling) {
                    const requestKey = `column-file-${this.data_source_id}-${actionData.destination_column}`;
                    this.stopPolling(requestKey);
                }
                
                // Prevent processing the same proposal multiple times
                if (this.isProcessingProposal && 
                    this.proposalModalData && 
                    this.proposalModalData.file_id === actionData.file_id &&
                    this.proposalModalData.destination_column === actionData.destination_column) {
                    return;
                }
                
                // Check if this notification is for this component's file
                if (actionData.file_id && parseInt(actionData.file_id) !== parseInt(this.data_source_id)) {
                    return;
                }
                
                // Mark as processing
                this.isProcessingProposal = true;
                
                // Re-enable the Edna button for the column that this proposal is for
                if (actionData.destination_column) {
                    const columnIndex = this.mapping.findIndex(c => c.destination_column === actionData.destination_column);
                    if (columnIndex !== -1) {
                        this.ednaButtonDisabled[columnIndex] = false;
                    }
                }
                
                // Fetch the proposal from file metadata
                window.axios.get(`/api/file-mapping/${this.client.url}/${actionData.file_id}/status`)
                    .then(response => {
                        const aiSuggestions = response.data.ai_suggestions || {};
                        const suggestion = aiSuggestions[actionData.destination_column];
                        
                        if (!suggestion || !suggestion.proposal) {
                            this.isProcessingProposal = false;
                            this.showNotification({
                                text: 'Column mapping suggestion not found. It may have already been processed.',
                                type: 'info'
                            });
                            return;
                        }
                        
                        // Set up proposal modal data for file
                        this.proposalModalData = {
                            file_id: actionData.file_id,
                            destination_column: actionData.destination_column,
                            proposal: suggestion.proposal,
                            reasoning: suggestion.output_text || null,
                            previous_response_id: suggestion.response_id || null,
                        };
                        
                        // Force re-render by updating key - this will cause the modal to mount
                        this.proposalModalKey += 1;
                        
                        // Wait for modal to be rendered and mounted, then show it
                        this.$nextTick(() => {
                            // Try multiple times with increasing delays to ensure modal is ready
                            const tryShowModal = (attempt = 1) => {
                                if (this.$refs.proposalModal) {
                                    if (typeof this.$refs.proposalModal.show === 'function') {
                                        this.$refs.proposalModal.show();
                                        // Clear processing flag after modal is shown
                                        this.isProcessingProposal = false;
                                    } else {
                                        // Modal might not be fully ready yet, try again
                                        if (attempt < 5) {
                                            setTimeout(() => tryShowModal(attempt + 1), 100);
                                        } else {
                                            console.error('ColumnMapping: Could not show file proposal modal after multiple attempts');
                                            this.isProcessingProposal = false;
                                        }
                                    }
                                } else {
                                    // Modal ref not available yet, try again
                                    if (attempt < 5) {
                                        setTimeout(() => tryShowModal(attempt + 1), 100);
                                    } else {
                                        console.error('ColumnMapping: File proposal modal ref not available after multiple attempts');
                                        this.isProcessingProposal = false;
                                    }
                                }
                            };
                            tryShowModal();
                        });
                    })
                    .catch(error => {
                        console.error('Error loading file proposal:', error);
                        this.isProcessingProposal = false;
                        this.showNotification({
                            text: 'Failed to load column mapping suggestion. Please try again.',
                            type: 'error'
                        });
                    });
            }
        },
        handleProposalAccepted(updatedColumnMapping) {
            // Clear processing flag when modal is closed/accepted
            this.isProcessingProposal = false;
            
            // Stop polling for this column since proposal was accepted
            if (updatedColumnMapping && updatedColumnMapping.destination_column) {
                const fileRequestKey = `column-file-${this.data_source_id}-${updatedColumnMapping.destination_column}`;
                const datasetRequestKey = `column-dataset-${this.data_source_id}-${updatedColumnMapping.destination_column}`;
                if (this.stopPolling) {
                    this.stopPolling(fileRequestKey);
                    this.stopPolling(datasetRequestKey);
                }
            }
            
            // Handle file proposals (applied directly to local dataset)
            if (updatedColumnMapping && updatedColumnMapping.file_id) {
                let columnIndex = this.mapping.findIndex(c => c.destination_column === updatedColumnMapping.destination_column);
                
                if (columnIndex === -1) {
                    // Column doesn't exist yet, need to create it
                    // Find the destination column info from dest_columns
                    const destColInfo = this.flat_dest_columns.find(c => c.column === updatedColumnMapping.destination_column);
                    if (destColInfo) {
                        const newColumn = {
                            destination_column: updatedColumnMapping.destination_column,
                            display_name: destColInfo.name || updatedColumnMapping.destination_column,
                            data_type: destColInfo.type || 'string',
                            source_column: updatedColumnMapping.source_column || null,
                            column_logic: updatedColumnMapping.column_logic || null,
                            id: null, // Temporary ID for new columns
                        };
                        this.mapping.push(newColumn);
                        columnIndex = this.mapping.length - 1;
                    } else {
                        // Destination column info not found, can't create
                        this.showNotification({
                            text: 'Could not find destination column information.',
                            type: 'error'
                        });
                        return;
                    }
                }
                
                if (columnIndex !== -1) {
                    // Create a new object to ensure Vue 3 reactivity detects the change
                    const updatedColumn = { ...this.mapping[columnIndex] };

                    updatedColumn.source_column = updatedColumnMapping.source_column;
                    updatedColumn.column_logic = updatedColumnMapping.column_logic;
                    
                    // Validate the logic to see if editing should be open
                    if(updatedColumn.column_logic) {
                        const isValid = this.isUnitValid(columnIndex, updatedColumn.column_logic.units);
                        updatedColumn.editing = !isValid;
                    }
                    else {
                        updatedColumn.editing = false;
                    }
                    
                    // Clear static text flags
                    updatedColumn.static_text = false;
                    updatedColumn.static_text_value = null;
                
                    // Replace the object in the array - Vue 3 will detect this change automatically
                    this.mapping[columnIndex] = updatedColumn;
                    
                    // Force Vue to update
                    this.$forceUpdate();
                    
                    this.showNotification({
                        icon: '/img/icons/nav-icons/Edna.svg',
                        text: 'Column mapping suggestion accepted and applied.',
                        type: 'success'
                    });
                } else {
                    // Column not found in mapping, refresh everything
                    if (this.setupScreen) {
                        this.setupScreen();
                    }
                }
                return;
            }
            
            // Handle dataset proposals (from API)
            if (updatedColumnMapping) {
                let columnIndex = this.mapping.findIndex(c => c.id === updatedColumnMapping.column_mapping_id);
                if (columnIndex === -1 && updatedColumnMapping.column_mapping_suggestion_id) {
                    columnIndex = this.mapping.findIndex(c => c.column_mapping_suggestion_id === updatedColumnMapping.column_mapping_suggestion_id);
                }
                if (columnIndex === -1 && updatedColumnMapping.destination_column) {
                    columnIndex = this.mapping.findIndex(c => c.destination_column === updatedColumnMapping.destination_column);
                }
                if (columnIndex !== -1) {
                    const updatedColumn = { ...this.mapping[columnIndex] };
                    updatedColumn.source_column = updatedColumnMapping.source_column;
                    updatedColumn.column_logic = updatedColumnMapping.column_logic;
                    if (updatedColumnMapping.column_mapping_id && (updatedColumn.id == null || updatedColumn.id < 0)) {
                        updatedColumn.id = updatedColumnMapping.column_mapping_id;
                        if (updatedColumnMapping.column_mapping_suggestion_id) {
                            this.temporarySuggestionIds = this.temporarySuggestionIds.filter(id => id !== updatedColumnMapping.column_mapping_suggestion_id);
                        }
                    }
                    if (updatedColumn.column_logic) {
                        const isValid = this.isUnitValid(columnIndex, updatedColumn.column_logic.units);
                        updatedColumn.editing = !isValid;
                    } else {
                        updatedColumn.editing = false;
                    }
                    updatedColumn.static_text = false;
                    updatedColumn.static_text_value = null;
                    this.mapping[columnIndex] = updatedColumn;
                } else {
                    if (this.setupScreen) {
                        this.setupScreen();
                    }
                }
            } else {
                // Fallback: refresh the entire mapping if no column definition provided
                if (this.setupScreen) {
                    this.setupScreen();
                }
            }
        },
        /**
         * Mark the component as saved. Called by parent component after successful save.
         * This prevents temporary column definitions from being rejected on unmount.
         */
        markAsSaved() {
            this.hasBeenSaved = true;
        },
        /**
         * Set all columns as generating. Called by parent component when starting bulk AI suggestions.
         */
        setAllColumnsGenerating() {
            for (let i = 0; i < this.mapping.length; i++) {
                this.ednaButtonDisabled[i] = true;
            }
        },
        /**
         * Clear generating state for all columns. Called by parent component when bulk AI suggestions complete.
         */
        clearAllColumnsGenerating() {
            for (let i = 0; i < this.mapping.length; i++) {
                this.ednaButtonDisabled[i] = false;
            }
        },
        /**
         * Clear generating state for a single column. Called when AI returns without a suggestion for that column.
         */
        clearColumnGenerating(destinationColumn) {
            const index = this.mapping.findIndex(c => c.destination_column === destinationColumn);
            if (index !== -1) {
                this.ednaButtonDisabled[index] = false;
            }
        },
    },
}
</script>